import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import { connect } from "react-redux";
import Moment from "react-moment";
import { ToastContainer, toast } from "react-toastify";
import { Toast } from "primereact/toast";
import { loyalityschemeActions } from "../../actions/loyalityschemeAction";
import { dealerMasterActions } from "../../actions";
import { productMasterActions } from "../../actions";
import { userMasterActions } from "../../actions";
import tableRequest from "../../models/tableRequest";
import Switch from "@material-ui/core/Switch";
import { Dropdown } from "primereact/dropdown";
import Multiselect from "multiselect-react-dropdown";
import { Calendar } from "primereact/calendar";
import { Chart } from "primereact/chart";
import { alertActions } from "../../actions/alertActions.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";

var minDate = new Date();

class loyalityscheme extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.LocRef = React.createRef();
    this.multiselectRefs = [];
    this.tblResponse = new tableRequest();
    this.statusBodyTemplate = this.statusBodyTemplate.bind(this);
    this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.onSelectState = this.onSelectState.bind(this);
    this.onRemoveState = this.onRemoveState.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.LocationSelectAll = this.LocationSelectAll.bind(this);
    this.getCityList = this.getCityList.bind(this);
    this.GetZoneWisePoint = this.GetZoneWisePoint.bind(this);
    this.onHidee = this.onHidee.bind(this);
    this.openDialogue = this.openDialogue.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.CreatedDateTemplate = this.CreatedDateTemplate.bind(this);
    this.UpdatedDateTemplate = this.UpdatedDateTemplate.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.onHide = this.onHide.bind(this);
    this.getRoleList = this.getRoleList.bind(this);
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.onPage1 = this.onPage1.bind(this);
    this.onSort1 = this.onSort1.bind(this);
    this.onRowSelect = this.onRowSelect.bind(this);
    this.submitseries = this.submitseries.bind(this);
    this.onChangeDDL = this.onChangeDDL.bind(this);
    this.onHideError = this.onHideError.bind(this);
    this.handleAllContractorChange = this.handleAllContractorChange.bind(this);
    this.handleSpecificContractorChange =
      this.handleSpecificContractorChange.bind(this);
    this.handleSpecificContractorRemove =
      this.handleSpecificContractorRemove.bind(this);
    this.handleContractorPointsChange =
      this.handleContractorPointsChange.bind(this);
    this.handleContractorZoneChange =
      this.handleContractorZoneChange.bind(this);
    this.removeContractor = this.removeContractor.bind(this);
    this.handleAutoFillContractorPoints =
      this.handleAutoFillContractorPoints.bind(this);
    this.addBlock = this.addBlock.bind(this);
    this.deleteBlock = this.deleteBlock.bind(this);
    this.handleBlockStateChange = this.handleBlockStateChange.bind(this);
    this.handleBlockZoneSelection = this.handleBlockZoneSelection.bind(this);
    this.handleBlockZoneRemove = this.handleBlockZoneRemove.bind(this);
    this.handleBlockPointsChange = this.handleBlockPointsChange.bind(this);
    this.handleBlockAutoFillPoints = this.handleBlockAutoFillPoints.bind(this);
    this.handleBlockSelectAll = this.handleBlockSelectAll.bind(this);
    this.handleBlockAllContractorChange =
      this.handleBlockAllContractorChange.bind(this);
    this.handleBlockSpecificContractorChange =
      this.handleBlockSpecificContractorChange.bind(this);
    this.handleBlockSpecificContractorRemove =
      this.handleBlockSpecificContractorRemove.bind(this);
    this.handleBlockContractorPointsChange =
      this.handleBlockContractorPointsChange.bind(this);
    this.handleBlockContractorZoneChange =
      this.handleBlockContractorZoneChange.bind(this);
    this.removeBlockContractor = this.removeBlockContractor.bind(this);
    this.handleBlockAutoFillContractorPoints =
      this.handleBlockAutoFillContractorPoints.bind(this);
    this.editMode = this.editMode.bind(this);
    this.setBasicFormState = this.setBasicFormState.bind(this);
    this.parseZoneContString = this.parseZoneContString.bind(this);
    this.parseZonesString = this.parseZonesString.bind(this);
    this.generateZoneId = this.generateZoneId.bind(this);
    this.parseStatesString = this.parseStatesString.bind(this);
    this.getZonesForBlockContractor =
      this.getZonesForBlockContractor.bind(this);
    this.getAvailableZonesForMainContractor =
      this.getAvailableZonesForMainContractor.bind(this);
    this.findZoneByStateAndName = this.findZoneByStateAndName.bind(this);
    this.findZoneByNameAndState = this.findZoneByNameAndState.bind(this);
    this.cleanZoneName = this.cleanZoneName.bind(this);
    this.validateZoneStateConsistency =
      this.validateZoneStateConsistency.bind(this);
    this.getContractorState = this.getContractorState.bind(this);

    this.architectBodyTemplate = this.architectBodyTemplate.bind(this);
    this.carpenterBodyTemplate = this.carpenterBodyTemplate.bind(this);

    this.state = {
      selectedProduct: "",
      productId: "",
      IsAdd: true,
      IsEdit: true,
      first: 0,
      rows: 5,
      totalRecords: 0,
      first1: 0,
      rows1: 5,
      totalRecords1: 0,
      globalFilter: null,
      sortOrder: "",
      buttonLabel: "Submit",
      switchAction: false,
      formHeading: "Add Loyality Master",
      UserId: 0,
      RoleId: 0,
      ValidFrm: "",
      ValidTo: "",
      city: "",
      state: "",
      SelectedDynamicId: [],
      Mappseriesdata: [],
      selectedProduct: null,
      SchemeCategoryData: [{ value: "1", label: "Loyalty Points" }],

      // Main contractor selection (for block 1)
      allContractorSelected: false,
      specificContractorIds: [],
      specificContractorPoints: {},
      specificContractorZones: {},
      specificContractorStates: {},
      SpecificContractorsData: [],

      // ARCHITECT ONLY - FRESH FLOW

      architectPincode: "",
      architectContractors: [],
      architectSelectedContractor: null,
      architectArchitects: [],
      architectSelectedArchitects: [],
      architectPoints: {},
      architectBlocks: [],

      // Dynamic Role Users
      loyaltySelectedRoleId: "",
      loyaltySelectedRoleName: "",
      loyaltyRoleUsers: [],
      loyaltySpecificUsers: [],
      loyaltyUserPoints: {},

      LoyaltyPointszonewise: [],
      productId: "",
      SchemeName: "",
      stateID: [],
      Schemedescription: "",
      SchemeCategory: "",
      product: "",
      category: "",
      Qty: 0,
      StartDate: new Date(),
      EndDate: new Date(),
      FromNo: 0,
      ToNo: 0,
      Status: "",
      loyalitypnt: "",
      IsActive: true,
      CreatedDate: null,
      UpdatedDate: null,
      isEditing: true,
      blocksSchemes: [
        {
          state: "",
          SelectedDynamicId: [],
          cityOptions: [],
          IsActive: true,
          autoFillPoints: false,
          hasAutoFilled: false,
          // Contractor selection for blocks 2,3,4,5
          allContractorSelected: false,
          specificContractorIds: [],
          specificContractorPoints: {},
          specificContractorZones: {},
          specificContractorStates: {},
        },
      ],
      formError: {
        SchemeName: "",
        SelectedDynamicId: null,
        category: "",
        loyalitypnt: "",
        RoleId: "",
        ValidFrm: "",
        ValidTo: "",
        state: "",
      },
      currentEditingId: null,
      allZones: [],
    };
  }

  toggleRowIsActive = async (rowData, checked) => {
    const updated = checked ? 1 : 0;

    await this.props.inActiveRow(rowData.SchemeId, updated);

    await this.props.fetchApi(this.buildTableRequest());
  };

  // Add this helper function to your class methods (outside of the Dialog render)
  filterContractorsBySelectedCities = (
    currentContractors,
    selectedCities,
    allContractorsData,
  ) => {
    // If no cities are selected, no contractors should remain (unless your logic dictates otherwise)
    if (!selectedCities || selectedCities.length === 0) {
      return [];
    }

    // 1. Get the list of City IDs that are still selected.
    const selectedCityIds = selectedCities.map(
      (city) => city.value || city.CityId,
    );
    const currentlyAvailableContractorIds = (
      this.getFilteredContractors(selectedCities) || []
    ).map((c) => c.value);

    // 3. Filter the currentContractors list to only keep those whose ID is in the currently available list.
    const filteredContractors = currentContractors.filter((contractor) =>
      currentlyAvailableContractorIds.includes(contractor.value),
    );

    return filteredContractors;
  };

  confirmDeleteCityRow = (blockIndex, cityRowIndex, cityRow) => {
    // 1. Get the current list of blocks
    const blocks = [...this.state.blocksSchemes];
    const currentBlock = blocks[blockIndex];

    // 2. Create the list of selected cities *after* removal
    const updatedSelectedList = currentBlock.SelectedDynamicId.filter(
      (_, i) => i !== cityRowIndex,
    );
    currentBlock.SelectedDynamicId = updatedSelectedList;

    // 3. Filter the related contractor list
    let newStateUpdates = { blocksSchemes: blocks };

    if (blockIndex === 0) {
      // Main Block
      const specificContractorIds = this.state.specificContractorIds || [];
      const newSpecificContractors = this.filterContractorsBySelectedCities(
        specificContractorIds,
        updatedSelectedList,
      );
      newStateUpdates.specificContractorIds = newSpecificContractors;
    } else {
      // Subsequent Blocks
      const specificContractorIds = currentBlock.specificContractorIds || [];
      const newSpecificContractors = this.filterContractorsBySelectedCities(
        specificContractorIds,
        updatedSelectedList,
      );

      // Update block's contractor list
      currentBlock.specificContractorIds = newSpecificContractors;
    }

    // 4. Update the state
    this.setState(newStateUpdates);
  };

  architectBodyTemplate = (rowData) => {
    if (!rowData.ArchitectDetails && !rowData.ArchitectName) {
      return <span>-</span>;
    }
    const name = rowData.ArchitectName || rowData.ArchitectDetails;
    const points = rowData.ArchitectPoints
      ? ` - ${rowData.ArchitectPoints}`
      : "";
    return <span>{`${name}${points}`}</span>;
  };

  carpenterBodyTemplate = (rowData) => {
    if (!rowData.CarpenterDetails && !rowData.CarpenterName) {
      return <span>-</span>;
    }
    const name = rowData.CarpenterName || rowData.CarpenterDetails;
    const points = rowData.CarpenterPoints
      ? ` - ${rowData.CarpenterPoints}`
      : "";
    return <span>{`${name}${points}`}</span>;
  };
  handleMainSpecificContractorChange = (list) => {
    this.setState({ specificContractorIds: list });
  };

  handleMainSpecificContractorRemove = (list, removedItem) => {
    this.setState({ specificContractorIds: list }, () => {
      // Remove points also
      const updated = { ...this.state.mainBlockContractorPoints };
      delete updated[removedItem.value];
      this.setState({ mainBlockContractorPoints: updated });
    });
  };

  handleBlockSelectAll = (event, blockIndex) => {
    const isChecked = event.target.checked;

    const blocks = [...this.state.blocksSchemes];
    const block = blocks[blockIndex];

    // ALWAYS reload cityOptions freshly (critical)
    const cityOptions = (this.props.ZoneData || []).filter(
      (z) => z.stateId === block.state,
    );

    let newSelectedZones = [];
    let newSelectedContractors = [];
    let updatedPoints = {};

    if (isChecked) {
      // Select all cities
      newSelectedZones = [...cityOptions];

      const contractorMap = this.state.allContractorsByCity || {};
      const zoneIds = newSelectedZones.map((z) => String(z.value || z.CityId));
      const unique = new Set();

      zoneIds.forEach((id) => {
        (contractorMap[id] || []).forEach((c) => {
          if (!unique.has(c.value)) {
            unique.add(c.value);
            newSelectedContractors.push(c);
          }
        });
      });

      updatedPoints = { ...(block.specificContractorPoints || {}) };
    } else {
      newSelectedZones = [];
      newSelectedContractors = [];
      updatedPoints = {};
    }

    // 🔥 Create a new object to force rerender
    const updatedBlock = {
      ...block,
      cityOptions: [...cityOptions], // NEW REFERENCE ALWAYS
      SelectedDynamicId: [...newSelectedZones],
      specificContractorIds: [...newSelectedContractors],
      specificContractorPoints: { ...updatedPoints },
      cityKey: Date.now(), // 🔥 FORCE RE-RENDER KEY
    };

    blocks[blockIndex] = updatedBlock;

    this.setState({ blocksSchemes: blocks });
  };

  handleBlockZoneSelection = (selectedList, addedItem, index) => {
    if (index > 0) {
      // Call the new helper function
      this.handleBlockSpecificContractorDefaultSelect(selectedList, index);
    }
    // ... rest of the handler
  };

  handleBlockSpecificContractorDefaultSelect = (selectedCitiesList, index) => {
    // 1. Identify all contractors relevant to the current city selection
    const relevantContractors = this.getFilteredContractors(selectedCitiesList);

    // 2. Extract the IDs of the relevant contractors
    const relevantContractorIds = relevantContractors.map((c) => c.value);

    // 3. Create the updated block structure
    const updatedBlocks = [...this.state.blocksSchemes];
    const currentBlock = updatedBlocks[index];

    // Get the block's current specific contractor IDs (handle potential null/undefined)
    const existingIds = currentBlock.specificContractorIds || [];

    // Use a Set to merge and ensure uniqueness
    const newSelectedContractorIds = [
      ...new Set([...existingIds, ...relevantContractorIds]),
    ];

    // 4. Update the state for the specific block
    currentBlock.specificContractorIds = newSelectedContractorIds;

    this.setState({
      blocksSchemes: updatedBlocks,
    });
  };

  // Example modification inside your handleBlockZoneSelection or a similar city selection handler

  handleBlockZoneSelection = (selectedList, addedItem, index) => {
    // ... existing logic to update blocksSchemes[index].SelectedDynamicId

    // 1. Get the updated list of selected cities for the current block
    const currentBlock = this.state.blocksSchemes[index];

    // Check if the current block is the Main Block (index 0)
    if (index === 0) {
      this.setState({
        blocksSchemes: blocks, // only update city, not contractors
      });
      return;
    } else {
    }
  };

  // Returns contractor objects for given IDs (used for MultiSelect)
  getContractorObjectsByIds = (ids) => {
    if (!ids || ids.length === 0 || !this.state.SpecificContractorsData)
      return [];
    const idSet = new Set(ids.map((id) => String(id)));
    return this.state.SpecificContractorsData.filter((c) =>
      idSet.has(String(c.value)),
    );
  };

  getFilteredContractors = (selectedCities) => {
    // If no city selected → return full contractor list
    if (!selectedCities || selectedCities.length === 0) {
      return this.state.masterContractors && this.state.masterContractors.length
        ? this.state.masterContractors
        : Array.isArray(this.props.contractDDL)
          ? this.props.contractDDL.map((item) => ({
              value: Number(item.UserId),
              label: item.DealerName,
              city: Number(item.City),
              cityName: item.CityName || "",
            }))
          : [];
    }

    const selectedCityIds = new Set(
      selectedCities.map((c) => String(Number(c.value))),
    );

    const master =
      this.state.masterContractors && this.state.masterContractors.length
        ? this.state.masterContractors
        : Array.isArray(this.props.contractDDL)
          ? this.props.contractDDL.map((item) => ({
              value: Number(item.UserId),
              label: item.DealerName,
              city: Number(item.City),
              cityName: item.CityName || "",
            }))
          : [];

    return (master || []).filter((ctr) =>
      selectedCityIds.has(String(ctr.city)),
    );
  };

  handleSpecificContractorChange = (selectedList) => {
    let contractor = selectedList[selectedList.length - 1]; // last selected contractor
    let blocks = [...this.state.blocksSchemes];

    let block = blocks[0]; // only block 1 specific contractors

    // if no zones selected in block, do nothing
    if (!block.SelectedDynamicId || block.SelectedDynamicId.length === 0) {
      this.setState({ specificContractorIds: selectedList });
      return;
    }

    // pick first selected zone
    const firstZone = block.SelectedDynamicId[0];

    // set zone for contractor
    block.specificContractorZones = {
      ...block.specificContractorZones,
      [contractor.value]: firstZone.value,
    };

    // set points for contractor (use same zone points)
    block.specificContractorPoints = {
      ...block.specificContractorPoints,
      [contractor.value]: firstZone.Points || 0,
    };

    this.setState({
      specificContractorIds: selectedList,
      blocksSchemes: blocks,
    });
  };

  // ENHANCED: Clean zone names more aggressively with strict validation
  cleanZoneName = (zones) => {
    if (!zones) return "";

    return zones
      .split(",")
      .map((z) => z.trim())
      .filter((z) => {
        // Keep only items where value is NOT 0
        const parts = z.split("-");
        const value = parseInt(parts[1]);
        return value !== 0;
      })
      .join(", ");
  };

  // NEW: Get contractor state from contractor data
  getContractorState = (contractorId) => {
    const contractor = this.state.SpecificContractorsData.find(
      (c) => c.value == contractorId,
    );
    return contractor?.state || "";
  };

  // IMPROVED FUNCTION: Find zone by name and state with better matching
  findZoneByNameAndState = (zoneName, stateId) => {
    const { allZones, blocksSchemes } = this.state;

    if (!zoneName) return null;

    const normalizedZoneName = this.cleanZoneName(zoneName)
      .toLowerCase()
      .trim();

    console.log(`🔍 Searching for zone: "${zoneName}" in state: ${stateId}`);

    // First, try exact match in allZones with stateId
    if (allZones && allZones.length > 0) {
      const exactMatch = allZones.find((zone) => {
        const zoneLabel = this.cleanZoneName(zone.label || "")
          .toLowerCase()
          .trim();
        const zoneStateId = zone.stateId || "";

        const isExactMatch =
          zoneLabel === normalizedZoneName &&
          (stateId ? zoneStateId == stateId : true);

        if (isExactMatch) {
          console.log(`✅ Exact match found in allZones:`, zone);
          return true;
        }
        return false;
      });

      if (exactMatch) return exactMatch;

      // Then try partial match in allZones
      const partialMatch = allZones.find((zone) => {
        const zoneLabel = this.cleanZoneName(zone.label || "")
          .toLowerCase()
          .trim();
        const zoneStateId = zone.stateId || "";

        const isPartialMatch =
          zoneLabel.includes(normalizedZoneName) &&
          (stateId ? zoneStateId == stateId : true);

        if (isPartialMatch) {
          console.log(`✅ Partial match found in allZones:`, zone);
          return true;
        }
        return false;
      });

      if (partialMatch) return partialMatch;
    }

    // Then try to find in block cityOptions
    for (let block of blocksSchemes) {
      if (block.cityOptions && block.cityOptions.length > 0) {
        const exactMatchInBlock = block.cityOptions.find((zone) => {
          const zoneLabel = this.cleanZoneName(zone.label || "")
            .toLowerCase()
            .trim();
          return zoneLabel === normalizedZoneName;
        });

        if (exactMatchInBlock) {
          console.log(
            `✅ Exact match found in block cityOptions:`,
            exactMatchInBlock,
          );
          return exactMatchInBlock;
        }

        const partialMatchInBlock = block.cityOptions.find((zone) => {
          const zoneLabel = this.cleanZoneName(zone.label || "")
            .toLowerCase()
            .trim();
          return zoneLabel.includes(normalizedZoneName);
        });

        if (partialMatchInBlock) {
          console.log(
            `✅ Partial match found in block cityOptions:`,
            partialMatchInBlock,
          );
          return partialMatchInBlock;
        }
      }
    }

    console.log(`❌ No zone found for: "${zoneName}" in state: ${stateId}`);
    return null;
  };

  // Keep the original function for backward compatibility
  findZoneByStateAndName = (stateId, zoneName) => {
    return this.findZoneByNameAndState(zoneName, stateId);
  };

  // FIXED: Get zones for main contractor - filter by contractor's state
  getAvailableZonesForMainContractor = (contractorId = null) => {
    const { allZones, blocksSchemes, specificContractorStates } = this.state;

    // If we have a specific contractor, use their state to filter zones
    if (contractorId) {
      const contractorStateId =
        specificContractorStates[contractorId] ||
        this.getContractorState(contractorId);

      if (contractorStateId) {
        // First, try to get zones from blocks that match the contractor's state
        const zonesFromMatchingBlocks = blocksSchemes.flatMap((block) =>
          block.state == contractorStateId && block.cityOptions
            ? block.cityOptions
            : [],
        );

        if (zonesFromMatchingBlocks.length > 0) {
          return zonesFromMatchingBlocks;
        }

        // Then try allZones filtered by state
        const zonesFromAllZones = allZones.filter(
          (zone) => zone.stateId == contractorStateId,
        );

        if (zonesFromAllZones.length > 0) {
          return zonesFromAllZones;
        }
      }
    }

    // Default: return all zones from the first block or all available zones
    if (blocksSchemes.length > 0 && blocksSchemes[0].cityOptions) {
      return blocksSchemes[0].cityOptions;
    }

    return allZones || [];
  };

  // Get zones for block contractors based on block state
  getZonesForBlockContractor = (blockIndex) => {
    const block = this.state.blocksSchemes[blockIndex];
    if (!block || !block.state) {
      return [];
    }

    // If the block has cityOptions (zones), use those
    if (block.cityOptions && block.cityOptions.length > 0) {
      return block.cityOptions;
    }

    // Otherwise, filter allZones by block state
    const stateId = block.state;
    const zonesForState = this.state.allZones.filter(
      (zone) => zone.stateId == stateId,
    );

    return zonesForState;
  };

  // FIXED: handleBlockSelectAll - Now properly resets Multiselect component
  handleBlockSelectAll = (e, index) => {
    const newBlocks = [...this.state.blocksSchemes];
    const block = newBlocks[index];

    console.log(`Select All for block ${index}:`, e.target.checked);
    console.log("Available cityOptions:", block.cityOptions);

    if (e.target.checked && block.cityOptions && block.cityOptions.length > 0) {
      const allZones = block.cityOptions.map((zone) => ({
        ...zone,
        Points: 0,
      }));

      newBlocks[index] = {
        ...block,
        SelectedDynamicId: allZones,
      };

      console.log(`Selected all ${allZones.length} zones for block ${index}`);
    } else {
      // IMPORTANT: Only clear SelectedDynamicId, don't touch cityOptions
      newBlocks[index] = {
        ...block,
        SelectedDynamicId: [], // Clear selections but keep cityOptions intact
      };

      // Force reset the Multiselect component
      setTimeout(() => {
        if (this.multiselectRefs[index]) {
          this.multiselectRefs[index].resetSelectedValues();
          console.log(`Reset Multiselect for block ${index}`);
        }
      }, 0);

      console.log(
        `Cleared all zone selections for block ${index}, but cityOptions remain:`,
        block.cityOptions,
      );
    }

    this.setState({ blocksSchemes: newBlocks }, () => {
      console.log(`After update - Block ${index}:`, {
        cityOptions: this.state.blocksSchemes[index].cityOptions,
        selectedZones: this.state.blocksSchemes[index].SelectedDynamicId,
      });
    });
  };

  // NEW: Validate zone-state consistency
  validateZoneStateConsistency = () => {
    const {
      specificContractorZones,
      specificContractorStates,
      blocksSchemes,
      allZones,
    } = this.state;

    let isValid = true;
    const errors = [];

    // Validate main contractors
    for (const [contractorId, zoneId] of Object.entries(
      specificContractorZones,
    )) {
      const expectedStateId =
        specificContractorStates[contractorId] ||
        this.getContractorState(contractorId);
      const zone = allZones.find((z) => z.value == zoneId);

      if (zone && expectedStateId && zone.stateId != expectedStateId) {
        console.error(
          `Zone-state mismatch for contractor ${contractorId}: zone state ${zone.stateId} vs expected ${expectedStateId}`,
        );
        errors.push(`Contractor ${contractorId} has zone from different state`);
        isValid = false;
      }
    }

    // Validate block contractors
    for (let i = 0; i < blocksSchemes.length; i++) {
      const block = blocksSchemes[i];
      const blockStateId = block.state;

      for (const [contractorId, zoneId] of Object.entries(
        block.specificContractorZones || {},
      )) {
        const zone = allZones.find((z) => z.value == zoneId);

        if (zone && zone.stateId != blockStateId) {
          console.error(
            `Zone-state mismatch for block ${i} contractor ${contractorId}: zone state ${zone.stateId} vs block state ${blockStateId}`,
          );
          errors.push(
            `Block ${i + 1} contractor ${contractorId} has zone from different state`,
          );
          isValid = false;
        }
      }
    }

    if (!isValid) {
      console.error("Zone-state validation errors:", errors);
    }

    return isValid;
  };

  switchToggleConfirm = async () => {
    try {
      await this.props.inActiveRow(
        this.state.SchemeId,
        this.state.switchAction,
      );

      await this.props.fetchApi(this.buildTableRequest());
    } catch (err) {
      console.error("Error in switchToggleConfirm:", err);
    }
  };

  // 1. Build request payload matching your API requirement
  buildArchiCarpenterRequest = () => {
    return {
      pageNo: Math.floor(this.state.first / this.state.rows) + 1,
      pageSize: this.state.rows,
      searchValue: this.state.globalFilter || "",
      sortColumn: this.state.sortField || "",
      sortOrder:
        this.state.sortOrder === 1
          ? "asc"
          : this.state.sortOrder === -1
            ? "desc"
            : "",
    };
  };

  // 2. Pagination handler for Archi Carpenter Table
  onPageArchiCarpenter = (event) => {
    this.setState(
      {
        first: event.first,
        rows: event.rows,
      },
      () => {
        this.props.getArchiCarpenterLoyaltyPoint(
          this.buildArchiCarpenterRequest(),
        );
      },
    );
  };

  // 3. Sorting handler for Archi Carpenter Table
  onSortArchiCarpenter = (event) => {
    this.setState(
      {
        sortField: event.sortField,
        sortOrder: event.sortOrder,
      },
      () => {
        this.props.getArchiCarpenterLoyaltyPoint(
          this.buildArchiCarpenterRequest(),
        );
      },
    );
  };

  componentDidMount() {
    const userDetails = sessionStorage.getItem("user");
    const userdetailsObject = JSON.parse(userDetails);

    this.setState({
      UserId: userdetailsObject?.UserId || null,
    });

    const userPages = sessionStorage.getItem("assignedPermissionsForUser");
    if (userPages) {
      const assignedPermissions = JSON.parse(userPages);
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + 7);

    this.tblResponse.FromDate = endDate.toLocaleDateString();
    this.tblResponse.ToDate = new Date().toLocaleDateString();

    this.setState({
      StartDate: new Date(),
      EndDate: endDate,
      Mappseriesdata: this.props.Mappseries,
    });
    this.props.getArchiCarpenterLoyaltyPoint(this.buildArchiCarpenterRequest());
    this.props.fetchApi(this.tblResponse);

    this.props.getRoleDDL("2");
    this.props.getRoleDLLforPoint("2");
    this.props.getCategoryDDL();
    this.props.getContractorDDL();
    this.props.getStateDDL(1);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.contractDDL !== this.props.contractDDL) {
      // FIXED: Include state information in contractor data
      const SpecificContractorsData = this.props.contractDDL.map((item) => ({
        value: item.UserId,
        label: item.DealerName,
        city: item.City,
        state: item.StateId || item.state || "", // Include state information
      }));

      this.setState({
        SpecificContractorsData,
      });
    }

    if (this.props.SchememappingData) {
      if (prevProps.SchememappingData !== this.props.SchememappingData) {
        if (this.props.SchememappingData && this.props.SchememappingData[0]) {
          this.setState({
            totalRecords: this.props.SchememappingData[0].TotalRows,
          });
        }
      }
    } else {
      if (this.state.totalRecords !== 0)
        this.setState({
          totalRecords: 0,
          first: 0,
        });
    }

    if (this.props.Mappseriesdata) {
      if (prevProps.Mappseriesdata !== this.props.Mappseriesdata) {
        if (this.props.Mappseriesdata) {
          this.setState({
            totalRecords1: this.props.Mappseriesdata[0]?.TotalRows1,
          });
        }
      }
    } else {
      if (this.state.totalRecords1 !== 0)
        this.setState({
          totalRecords1: 0,
          first1: 0,
        });
    }

    if (this.props.loyaltypoints != []) {
      if (prevProps.loyaltypoints !== this.props.loyaltypoints) {
        this.setState({
          SelectedDynamicId: this.props.loyaltypoints,
          stateID: this.props.loyaltypoints,
        });
      }
    } else {
      this.setState({
        SelectedDynamicId: [],
        stateID: [],
      });
    }

    if (
      this.props.UserBCityData &&
      prevProps.UserBCityData !== this.props.UserBCityData
    ) {
      const allZones = this.props.UserBCityData.map((city) => ({
        label: city.name || city.cityName || city.label,
        value: city.id || city.cityId || city.value,
        stateId: city.stateId || this.getStateForCity(city),
      }));

      this.setState({ allZones });
    }
  }

  getStateForCity = (city) => {
    return city.stateId || city.state || "";
  };

  // Parse States String - Now correctly handles "StateName-StateId" format
  parseStatesString = (statesString) => {
    if (!statesString) return [];

    try {
      console.log("Parsing states string:", statesString);

      // Split by comma and trim each state
      const statesArray = statesString.split(",").map((state) => state.trim());

      // Extract state IDs from format like "Andaman & Nicobar Islands-1"
      const parsedStates = statesArray.map((state) => {
        const lastDashIndex = state.lastIndexOf("-");
        if (lastDashIndex !== -1) {
          const stateName = state.substring(0, lastDashIndex).trim();
          const stateId = state.substring(lastDashIndex + 1).trim();

          // Validate that stateId is a number
          if (!isNaN(stateId)) {
            return {
              name: stateName,
              id: parseInt(stateId),
              originalString: state,
            };
          } else {
            return {
              name: state,
              id: "", // Unknown ID
              originalString: state,
            };
          }
        } else {
          // If no dash, try to extract numeric ID
          const match = state.match(/(.*?)(\d+)$/);
          if (match) {
            return {
              name: match[1].trim(),
              id: parseInt(match[2].trim()),
              originalString: state,
            };
          } else {
            return {
              name: state,
              id: "", // Unknown ID
              originalString: state,
            };
          }
        }
      });

      console.log("Parsed states result:", parsedStates);
      return parsedStates;
    } catch (error) {
      console.error("Error parsing states string:", error, statesString);
      return [];
    }
  };

  parseZonesString = (zonesString) => {
    if (!zonesString || typeof zonesString !== "string") return [];

    return zonesString
      .split(",")
      .map((zone) => {
        const match = zone
          .trim()
          .match(/(.+?)\s*\((\d+)\)\s*-\s*(\d+(?:\.\d+)?)/);
        if (!match) return null;

        const label = match[1].trim();
        const stateId = Number(match[2]);
        const points = Number(match[3]);
        const cityId = this.findCityId(label); // <-- IMPORTANT FIXED

        return {
          label,
          stateId,
          Points: points,
          value: cityId, // <-- CORRECT VALUE NOW
        };
      })
      .filter(Boolean);
  };

  loadAllZoneCities = async () => {
    try {
      const res = await this.props.GetAvailableseries(); // Or whatever API returns zones
      const formatted = (res || []).map((z) => ({
        label: z.CityName || z.ZoneName || "",
        value: z.CityId || z.ZoneId,
        stateId: z.StateId,
      }));
      this.setState({ AllZoneCities: formatted });
    } catch (err) {
      console.error("Error loading zone/cities:", err);
    }
  };

  findCityId = (label) => {
    const allCities = this.state.AllZoneCities || this.state.cityOptions || [];

    const city = allCities.find(
      (c) => c.label.trim().toLowerCase() === label.trim().toLowerCase(),
    );

    return city ? Number(city.value) : null;
  };

  parseZoneContString = (zoneContString) => {
    if (!zoneContString) return [];

    try {
      const entries = zoneContString.split(/\s*,\s*/); // split by comma
      const contractors = [];

      entries.forEach((entry) => {
        if (!entry.trim()) return;

        // Extract Contractor Name → (XYZ)
        const nameMatch = entry.match(/\((.*?)\)/);
        const contractorName = nameMatch ? nameMatch[1].trim() : "Unknown";

        // Remove the first (Name) so we can parse city/state properly
        const remaining = entry.replace(/\(.*?\)\s*/, "");

        // Extract City
        const cityMatch = remaining.match(/(.*?)\s*\(/);
        const city = cityMatch ? cityMatch[1].trim() : "";

        // Extract StateId (inside parentheses)
        const stateMatch = remaining.match(/\((\d+)\)/);
        const stateId = stateMatch ? stateMatch[1] : "";

        // Extract Points (after "-")
        const pointsMatch = remaining.match(/-\s*(\d+(?:\.\d+)?)/);
        const points = pointsMatch ? pointsMatch[1] : "0";

        contractors.push({
          contractorName,
          city,
          stateId,
          points,
        });
      });

      return contractors;
    } catch (err) {
      console.error("ZoneCont parse error:", err);
      return [];
    }
  };

  // ENHANCED: Helper function to generate zone ID - Now prefers numeric IDs
  generateZoneId = (zoneName, stateId = null) => {
    // First, try to extract numeric ID from zone name if it exists
    const numericMatch = zoneName.match(/(\d+)$/);
    if (numericMatch) {
      return parseInt(numericMatch[1]);
    }

    // If we have stateId, try to create a numeric ID by combining stateId and a hash of the name
    if (stateId) {
      // Create a simple hash of the zone name
      let hash = 0;
      for (let i = 0; i < zoneName.length; i++) {
        hash = (hash << 5) - hash + zoneName.charCodeAt(i);
        hash = hash & hash; // Convert to 32bit integer
      }
      // Combine stateId and hash to create a unique numeric ID
      return Math.abs(stateId * 1000 + (hash % 1000));
    }

    // Fallback: try to find the zone in allZones to get its numeric ID
    if (this.state.allZones && this.state.allZones.length > 0) {
      const foundZone = this.state.allZones.find((zone) =>
        zone.label.toLowerCase().includes(zoneName.toLowerCase()),
      );
      if (foundZone && typeof foundZone.value === "number") {
        return foundZone.value;
      }
    }

    // Last resort: use string ID but ensure it's handled properly in backend
    console.warn(
      `Using string ID for zone: ${zoneName}. This may cause backend errors.`,
    );
    return zoneName
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[\(\)]/g, "");
  };

  // Main Contractor Functions (for Block 1)
  handleAllContractorChange = (e) => {
    const isChecked = e.target.checked;

    this.setState(
      {
        allContractorSelected: isChecked,
      },
      () => {
        this.updateSelectedDynamicId();
      },
    );
  };

  handleSpecificContractorChange = (selectedList) => {
    const newPoints = { ...this.state.specificContractorPoints };
    const newZones = { ...this.state.specificContractorZones };
    const newStates = { ...this.state.specificContractorStates };

    selectedList.forEach((contractor) => {
      if (!newPoints[contractor.value]) {
        newPoints[contractor.value] = 0;
      }
      if (!newZones[contractor.value]) {
        newZones[contractor.value] = "";
      }
      // FIXED: Set contractor state from contractor data
      if (!newStates[contractor.value]) {
        newStates[contractor.value] = contractor.state || "";
      }
    });

    this.setState(
      {
        specificContractorIds: selectedList,
        specificContractorPoints: newPoints,
        specificContractorZones: newZones,
        specificContractorStates: newStates,
      },
      () => {
        this.updateSelectedDynamicId();
      },
    );
  };

  handleSpecificContractorRemove = (selectedList, removedItem) => {
    const newPoints = { ...this.state.specificContractorPoints };
    const newZones = { ...this.state.specificContractorZones };
    const newStates = { ...this.state.specificContractorStates };

    delete newPoints[removedItem.value];
    delete newZones[removedItem.value];
    delete newStates[removedItem.value];

    this.setState(
      {
        specificContractorIds: selectedList,
        specificContractorPoints: newPoints,
        specificContractorZones: newZones,
        specificContractorStates: newStates,
      },
      () => {
        this.updateSelectedDynamicId();
      },
    );
  };

  updateSelectedDynamicId = () => {
    const {
      allContractorSelected,
      specificContractorIds,
      specificContractorPoints,
      specificContractorZones,
      specificContractorStates,
    } = this.state;

    let updatedSelectedDynamicId = [];

    if (allContractorSelected) {
      updatedSelectedDynamicId.push({
        type: "allContractor",
        value: "all",
        label: "All Contractor",
        points: 0,
        zone: "",
      });
    }

    specificContractorIds.forEach((contractor) => {
      updatedSelectedDynamicId.push({
        type: "specificContractor",
        value: contractor.value,
        label: contractor.label,
        points: specificContractorPoints[contractor.value] || 0,
        zone: specificContractorZones[contractor.value] || "",
        state: specificContractorStates[contractor.value] || "",
        city: contractor.city || "",
      });
    });

    this.setState({
      SelectedDynamicId: updatedSelectedDynamicId,
    });
  };

  // FIXED: Main contractor zone change handler
  handleContractorPointsChange = (contractorId, points) => {
    this.setState(
      {
        specificContractorPoints: {
          ...this.state.specificContractorPoints,
          [contractorId]: parsefl(points) || 0,
        },
      },
      () => {
        this.updateSelectedDynamicId();
      },
    );
  };

  // FIXED: Main contractor zone change handler with state validation
  handleContractorZoneChange = (contractorId, zoneId) => {
    const availableZones =
      this.getAvailableZonesForMainContractor(contractorId);
    const selectedZone = availableZones.find((zone) => zone.value == zoneId);

    if (!selectedZone) {
      console.warn(
        `Zone ${zoneId} not found in available zones for contractor ${contractorId}`,
      );
      return;
    }

    const stateId = selectedZone.stateId || "";
    const zoneLabel = selectedZone.label || "";

    console.log(
      `Main Contractor - Setting zone for contractor ${contractorId}:`,
      {
        zoneId,
        stateId,
        zoneLabel,
        selectedZone,
      },
    );

    this.setState(
      {
        specificContractorZones: {
          ...this.state.specificContractorZones,
          [contractorId]: zoneId,
        },
        // Don't update state here - it should come from contractor data or previous setting
      },
      () => {
        console.log(`After setting - Main contractor ${contractorId}:`, {
          zone: this.state.specificContractorZones[contractorId],
          state: this.state.specificContractorStates[contractorId],
        });
        this.updateSelectedDynamicId();
      },
    );
  };

  removeContractor = (contractorId) => {
    const updatedContractors = this.state.specificContractorIds.filter(
      (contractor) => contractor.value !== contractorId,
    );

    const updatedPoints = { ...this.state.specificContractorPoints };
    const updatedZones = { ...this.state.specificContractorZones };
    const updatedStates = { ...this.state.specificContractorStates };

    delete updatedPoints[contractorId];
    delete updatedZones[contractorId];
    delete updatedStates[contractorId];

    this.setState(
      {
        specificContractorIds: updatedContractors,
        specificContractorPoints: updatedPoints,
        specificContractorZones: updatedZones,
        specificContractorStates: updatedStates,
      },
      () => {
        this.updateSelectedDynamicId();
      },
    );
  };

  handleAutoFillContractorPoints = (points) => {
    const newPoints = {};
    this.state.specificContractorIds.forEach((contractor) => {
      newPoints[contractor.value] = parseInt(points) || 0;
    });

    this.setState(
      {
        specificContractorPoints: newPoints,
      },
      () => {
        this.updateSelectedDynamicId();
      },
    );
  };

  handleBlockAllContractorChange = (e, index) => {
    const isChecked = e.target.checked;
    const newBlocks = [...this.state.blocksSchemes];

    newBlocks[index] = {
      ...newBlocks[index],
      allContractorSelected: isChecked,
    };

    this.setState({ blocksSchemes: newBlocks });
  };

  handleBlockSpecificContractorChange = (selectedList, index) => {
    const blocks = [...this.state.blocksSchemes];
    const block = blocks[index];

    // Ensure label + value
    const formattedList = selectedList.map((c) => ({
      label: c.label,
      value: c.value,
    }));

    const newPoints = { ...block.specificContractorPoints };
    const newZones = { ...block.specificContractorZones };
    const newStates = { ...block.specificContractorStates };

    // Add default values if contractor added
    formattedList.forEach((c) => {
      if (!newPoints[c.value]) newPoints[c.value] = 0;
      if (!newZones[c.value]) newZones[c.value] = "";
      if (!newStates[c.value]) newStates[c.value] = block.state || "";
    });

    blocks[index] = {
      ...block,
      specificContractorIds: formattedList,
      specificContractorPoints: newPoints,
      specificContractorZones: newZones,
      specificContractorStates: newStates,
    };

    this.setState({ blocksSchemes: blocks });
  };

  handleBlockSpecificContractorRemove = (selectedList, removedItem, index) => {
    const blocks = [...this.state.blocksSchemes];
    const block = blocks[index];

    const formattedList = selectedList.map((c) => ({
      label: c.label,
      value: c.value,
    }));

    const newPoints = { ...block.specificContractorPoints };
    const newZones = { ...block.specificContractorZones };
    const newStates = { ...block.specificContractorStates };

    // remove data of removed contractor
    delete newPoints[removedItem.value];
    delete newZones[removedItem.value];
    delete newStates[removedItem.value];

    blocks[index] = {
      ...block,
      specificContractorIds: formattedList,
      specificContractorPoints: newPoints,
      specificContractorZones: newZones,
      specificContractorStates: newStates,
    };

    this.setState({ blocksSchemes: blocks });
  };

  handleBlockContractorPointsChange = (contractorId, points, index) => {
    const newBlocks = [...this.state.blocksSchemes];
    const block = newBlocks[index];

    newBlocks[index] = {
      ...block,
      specificContractorPoints: {
        ...block.specificContractorPoints,
        [contractorId]: parseFloat(points) || 0,
      },
    };

    this.setState({ blocksSchemes: newBlocks });
  };

  // FIXED: Block contractor zone change handler with state validation
  handleBlockContractorZoneChange = (contractorId, zoneId, index) => {
    const newBlocks = [...this.state.blocksSchemes];
    const block = newBlocks[index];

    if (!block) {
      console.warn(`Block at index ${index} does not exist`);
      return;
    }

    // Ensure specificContractorZones object exists
    const existingZones = block.specificContractorZones || {};

    // Get zones only for this block's state
    const blockZones = this.getZonesForBlockContractor(index) || [];

    const selectedZone = blockZones.find(
      (z) => String(z.value) === String(zoneId),
    );

    if (!selectedZone) {
      console.warn(`Zone ${zoneId} not found for block ${index}`);
      return;
    }

    console.log(`Block ${index} - Updating contractor ${contractorId} zone:`, {
      zoneId,
      selectedZone,
    });

    // 🔥 Update block
    newBlocks[index] = {
      ...block,
      specificContractorZones: {
        ...existingZones,
        [contractorId]: zoneId,
      },
    };

    // Update state
    this.setState({ blocksSchemes: newBlocks }, () => {
      console.log(`After update - Block ${index} Contractor ${contractorId}`, {
        zone: newBlocks[index].specificContractorZones?.[contractorId],
        state: newBlocks[index].specificContractorStates?.[contractorId],
      });
    });
  };

  removeBlockContractor = (contractorId, index) => {
    const newBlocks = [...(this.state.blocksSchemes || [])];
    const block = newBlocks[index];

    const updatedContractors = block.specificContractorIds.filter(
      (contractor) => Number(contractor.value) !== Number(contractorId),
    );

    const updatedPoints = { ...block.specificContractorPoints };
    delete updatedPoints[contractorId];

    newBlocks[index] = {
      ...block,
      specificContractorIds: updatedContractors,
      specificContractorPoints: updatedPoints,
    };

    this.setState({ blocksSchemes: newBlocks });
  };

  handleBlockAutoFillContractorPoints = (points, index) => {
    const newBlocks = [...this.state.blocksSchemes];
    const block = newBlocks[index];

    const newPoints = {};
    block.specificContractorIds.forEach((contractor) => {
      newPoints[contractor.value] = parseInt(points) || 0;
    });

    newBlocks[index] = {
      ...block,
      specificContractorPoints: newPoints,
    };

    this.setState({ blocksSchemes: newBlocks });
  };

  handleBlockStateChange = async (e, index) => {
    const selectedState = e.target.value;
    const newBlocks = [...this.state.blocksSchemes];

    newBlocks[index] = {
      ...newBlocks[index],
      state: selectedState,
      cityOptions: [],
      SelectedDynamicId: [],
      autoFillPoints: false,
      hasAutoFilled: false,
    };

    this.setState({ blocksSchemes: newBlocks });

    if (selectedState) {
      try {
        const cityData = await this.props.getBCityDDL(selectedState);
        const cityOptions = (cityData || []).map((city) => ({
          label: city.name || city.cityName || city.label,
          value: city.id || city.cityId || city.value,
        }));

        const updatedBlocks = [...this.state.blocksSchemes];
        updatedBlocks[index] = {
          ...updatedBlocks[index],
          cityOptions: cityOptions,
        };

        this.setState({ blocksSchemes: updatedBlocks });
      } catch (error) {
        console.error("Error loading cities for state:", error);
      }
    }
  };

  handleBlockZoneSelection = (selectedList, selectedItem, index) => {
    const newBlocks = [...this.state.blocksSchemes];
    const currentBlock = newBlocks[index];

    // ⭐ 1. Update ONLY the block's city selection
    const updatedSelectedList = selectedList.map((zone) => ({
      ...zone,
      Points: zone.Points || 0,
    }));

    newBlocks[index] = {
      ...currentBlock,
      SelectedDynamicId: updatedSelectedList,
    };

    this.setState({
      blocksSchemes: newBlocks,
    });
  };

  handleBlockZoneRemove = (updatedSelectedList, removedItem, index) => {
    const blocks = [...this.state.blocksSchemes];
    blocks[index].SelectedDynamicId = updatedSelectedList;

    // Determine which contractor list to update (main block or subsequent blocks)
    let specificContractorIds;
    let mainBlockContractorPoints;
    let specificContractorPoints;

    if (index === 0) {
      // Main block contractor logic
      specificContractorIds = this.state.specificContractorIds || [];
      mainBlockContractorPoints = this.state.mainBlockContractorPoints || {};

      // Filter the main block's specific contractors
      const newSpecificContractors = this.filterContractorsBySelectedCities(
        specificContractorIds,
        updatedSelectedList,
      );

      // Update the state
      this.setState({
        blocksSchemes: blocks,
        specificContractorIds: newSpecificContractors,
      });
    } else {
      // Subsequent block contractor logic
      specificContractorIds = blocks[index].specificContractorIds || [];
      specificContractorPoints = blocks[index].specificContractorPoints || {};

      // Filter the block's specific contractors
      const newSpecificContractors = this.filterContractorsBySelectedCities(
        specificContractorIds,
        updatedSelectedList,
      );

      // Update the block's state
      blocks[index].specificContractorIds = newSpecificContractors;
      this.setState({ blocksSchemes: blocks });
    }
  };

  handleBlockPointsChange = (zoneIndex, points, blockIndex) => {
    const newBlocks = [...this.state.blocksSchemes];
    const block = newBlocks[blockIndex];

    const updatedZones = [...block.SelectedDynamicId];

    updatedZones[zoneIndex] = {
      ...updatedZones[zoneIndex],
      Points: points,
    };

    newBlocks[blockIndex] = {
      ...block,
      SelectedDynamicId: updatedZones,
    };

    this.setState({ blocksSchemes: newBlocks });
  };
  handleBlockAutoFillPoints = (points, blockIndex) => {
    const newBlocks = [...this.state.blocksSchemes];
    const block = newBlocks[blockIndex];

    const updatedZones = block.SelectedDynamicId.map((zone) => ({
      ...zone,
      Points: points,
    }));

    newBlocks[blockIndex] = {
      ...block,
      SelectedDynamicId: updatedZones,
      autoFillPoints: true,
      hasAutoFilled: true,
    };

    this.setState({ blocksSchemes: newBlocks });
  };

  // addBlock = () => {
  //   this.setState((prevState) => {
  //     if (prevState.blocksSchemes.length >= 5) {
  //       toast.warn("Maximum 5 blocks allowed");
  //       return null;
  //     }

  //     return {
  //       blocksSchemes: [
  //         ...prevState.blocksSchemes,
  //         {
  //           state: "",
  //           SelectedDynamicId: [],
  //           cityOptions: [],
  //           IsActive: true,
  //           autoFillPoints: false,
  //           hasAutoFilled: false,
  //           allContractorSelected: false,
  //           specificContractorIds: [],
  //           specificContractorPoints: {},
  //           specificContractorZones: {},
  //           specificContractorStates: {},
  //         },
  //       ],
  //     };
  //   });
  // };
  addBlock = () => {
    this.setState((prevState) => {
      if (prevState.blocksSchemes.length >= 5) {
        toast.warn("Maximum 5 blocks allowed");
        return null;
      }

      const newBlock = {
        state: "",
        SelectedDynamicId: [],
        cityOptions: [],
        IsActive: true,
        autoFillPoints: false,
        hasAutoFilled: false,

        // OLD FLOW
        allContractorSelected: false,
        specificContractorIds: [],
        specificContractorPoints: {},
        specificContractorZones: {},
        specificContractorStates: {},
      };

      const newArchitectBlock = {
        pincode: "",
        contractors: [],
        selectedContractor: null,
        architects: [],
        selectedArchitects: [],
        points: {},

        stateId: 0,
        zoneId: 0,
      };

      return {
        blocksSchemes: [...prevState.blocksSchemes, newBlock],

        architectBlocks: [
          ...(prevState.architectBlocks || []),
          newArchitectBlock,
        ],
      };
    });
  };

  deleteBlock = (index) => {
    if (this.state.blocksSchemes.length <= 1) {
      toast.warn("At least one block is required");
      return;
    }

    this.setState((prevState) => {
      const newBlocks = [...prevState.blocksSchemes];
      newBlocks.splice(index, 1);
      return { blocksSchemes: newBlocks };
    });
  };

  findCityId = (label) => {
    const city = this.state.cityOptions.find(
      (c) => c.label.trim().toLowerCase() === label.trim().toLowerCase(),
    );
    return city ? city.value : null;
  };

  // FIXED: editMode function - Now properly calls setBasicFormState without setTimeout
  // editMode = async (rowData) => {

  //   this.props.onHideShow(true);

  //   // Directly call setBasicFormState without setTimeout
  //   await this.setBasicFormState(rowData);

  //    // 🔒 LOCK editing if expired
  // if (this.isExpiredBenefit()) {
  //   this.setState({ isEditing: false });
  // }
  // };

  editMode = async (rowData) => {
    this.props.onHideShow(true);

    await this.setBasicFormState(rowData);

    // expired → lock editing
    if (this.isExpiredBenefit()) {
      this.setState({ isEditing: false });
    } else {
      this.setState({ isEditing: true });
    }
  };

  removeMainContractor = (contractorId) => {
    const updatedContractors = (this.state.specificContractorIds || []).filter(
      (contractor) => Number(contractor.value) !== Number(contractorId),
    );

    const updatedPoints = { ...(this.state.mainBlockContractorPoints || {}) };
    delete updatedPoints[contractorId];

    this.setState({
      specificContractorIds: updatedContractors,
      mainBlockContractorPoints: updatedPoints,
    });
  };

  confirmDeleteMainContractor = (contractorId) => {
    const yes = window.confirm(
      "Are you sure you want to remove this contractor?",
    );

    if (yes) {
      this.removeMainContractor(contractorId);
    }
  };

  setBasicFormState = async (rowData) => {
    const toNum = (v) => Number(v) || 0;

    const roleId = rowData.RoleId;

    const selectedRole = (this.props.loyaltyRoleDropdownData || []).find(
      (role) => String(role.value) === String(roleId),
    );

    const roleName = selectedRole?.label || "";

    const parseZoneCont = (zoneStr, zoneContIdsCsv, contractorIdsCsv) => {
      if (!zoneStr) return [];

      const zoneIds = zoneContIdsCsv
        ? zoneContIdsCsv.split(",").map(toNum)
        : [];
      const userIds = contractorIdsCsv
        ? contractorIdsCsv.split(",").map(toNum)
        : [];

      return zoneStr
        .split(",")
        .map((x, idx) => {
          const txt = x.trim();
          const m = txt.match(
            /\((.*?)\)\s*(.*?)\s*\((\d+)\)\s*-\s*(\d+(?:\.\d+)?)/,
          );
          if (!m) return null;

          return {
            contractorName: m[1].trim(),
            contractorId: userIds[idx] || null,
            zoneName: m[2].trim(),
            stateId: toNum(m[3]),
            points: toNum(m[4]),
            zoneId: zoneIds[idx] || null,
          };
        })
        .filter(Boolean);
    };

    const parsedZoneCont = parseZoneCont(
      rowData.ZoneCont,
      rowData.ZoneContIds,
      rowData.ContractorIds,
    );

    /* -------------------------
       Parse States (FIXED PART)
    ------------------------- */
    const stateMap = {};

    // from State column (general)
    (rowData.State || "").split(",").forEach((s) => {
      const m = s.trim().match(/(.+?)-\s*(\d+)/);
      if (m) {
        const id = toNum(m[2]);
        stateMap[id] = { id, name: m[1].trim() };
      }
    });

    // from contractor rows (IMPORTANT FIX)
    parsedZoneCont.forEach((p) => {
      if (!stateMap[p.stateId]) {
        stateMap[p.stateId] = { id: p.stateId, name: String(p.stateId) };
      }
    });

    const states = Object.values(stateMap);

    /* -------------------------
       Parse Zones (UNCHANGED)
    ------------------------- */
    const parseZones = (zonesStr, idsCsv) => {
      if (!zonesStr) return [];

      const ids = idsCsv ? idsCsv.split(",").map(toNum) : [];
      const rows = zonesStr.split(",").map((x) => x.trim());

      return rows
        .map((row, i) => {
          const m = row.match(/(.+?)\s*\((\d+)\)\s*-\s*(\d+(?:\.\d+)?)/);
          if (!m) return null;
          return {
            label: m[1].trim(),
            stateId: toNum(m[2]),
            Points: toNum(m[3]),
            value: ids[i] || null,
          };
        })
        .filter(Boolean);
    };

    const parsedZones = parseZones(rowData.Zones, rowData.ZoneIds);

    /* -------------------------
       Load City Options (UNCHANGED)
    ------------------------- */
    const allCityOptions = [];
    const seenStateIds = new Set();

    await Promise.all(
      states.map(async (s) => {
        if (!s?.id || seenStateIds.has(s.id)) return;
        seenStateIds.add(s.id);

        try {
          const res = await this.props.getBCityDDL(s.id);
          (res || []).forEach((c) =>
            allCityOptions.push({
              value: toNum(c.value || c.CityId),
              label: (c.label || c.CityName || "").trim(),
              stateId: s.id,
            }),
          );
        } catch (err) {
          console.warn("City load error for state", s.id, err);
        }
      }),
    );

    /* -------------------------
       Build Blocks (UNCHANGED)
    ------------------------- */
    const allContractorData = this.props.SpecificContractorsData || [];
    const blockAllFlags = (rowData.BlockAllContractor || "")
      .split(",")
      .map((x) => Number(x) === 1);

    const blocks = states.map((st, idx) => {
      const sid = st.id;

      const zonesForState = parsedZones.filter((z) => z.stateId === sid);
      let selectedCities = [];

      if (zonesForState.length) {
        selectedCities = allCityOptions
          .filter(
            (c) =>
              c.stateId === sid &&
              zonesForState.some((z) => z.value === c.value),
          )
          .map((c) => {
            const zoneMatch = zonesForState.find((z) => z.value === c.value);
            return { ...c, Points: zoneMatch?.Points || 0 };
          });
      } else {
        const contRows = parsedZoneCont.filter((pc) => pc.stateId === sid);
        selectedCities = contRows.map((pc) => {
          let city = allCityOptions.find(
            (c) =>
              c.stateId === sid &&
              c.label &&
              c.label.toLowerCase() === pc.zoneName.toLowerCase(),
          );

          if (!city && pc.zoneId) {
            city = allCityOptions.find((c) => c.value === pc.zoneId);
          }

          return {
            ...(city || {}),
            value: city?.value || pc.zoneId,
            label: city?.label || pc.zoneName,
            stateId: sid,
            Points: pc.points || 0,
          };
        });
      }

      const ctrRows = parsedZoneCont.filter((c) => c.stateId === sid);
      const ctrPoints = {};
      const ctrIds = [];

      ctrRows.forEach((c) => {
        if (c.contractorId != null) {
          ctrPoints[c.contractorId] = c.points;
          const contractorInfo = allContractorData.find(
            (d) => d.value == c.contractorId,
          );
          ctrIds.push({
            label: contractorInfo?.label || c.contractorName,
            value: c.contractorId,
          });
        }
      });

      return {
        state: String(sid),
        cityOptions: allCityOptions.filter((c) => c.stateId === sid),
        SelectedDynamicId: selectedCities,
        specificContractorIds: ctrIds,
        specificContractorPoints: ctrPoints,
        IsActive: rowData.IsActive === true,
        allContractorSelected: blockAllFlags[idx] || false,
      };
    });

    /* -------------------------
       ALL CONTRACTOR AUTO FIX (UNCHANGED)
    ------------------------- */
    blocks.forEach((block) => {
      const stateId = Number(block.state);

      const generalRows = parsedZones.filter((z) => z.stateId === stateId);
      const contractorRows = parsedZoneCont.filter(
        (c) => c.stateId === stateId,
      );

      if (generalRows.length) {
        block.allContractorSelected = generalRows.some((z) => z.Points > 0);
      } else {
        block.allContractorSelected = contractorRows.length === 0;
      }
    });

    /* -------------------------
       Final setState (UNCHANGED)
    ------------------------- */
    const block1 = blocks[0] || {};

    this.setState(
      {
        buttonLabel: "Update",
        formHeading: "Update Scheme",
        currentEditingId: rowData.SchemeId,
        // isEditing: true,
        isEditing: !this.isExpiredBenefit(),

        loyaltySelectedRoleId: roleId || "",
        loyaltySelectedRoleName: roleName,

        SchemeId: rowData.SchemeId,
        SchemeName: rowData.SchemeName || "",
        Schemedescription: rowData.Schemedescription || "",
        category: rowData.GroupId || "",

        ValidFrm: rowData.ValidFrm ? new Date(rowData.ValidFrm) : "",
        ValidTo: rowData.ValidTo ? new Date(rowData.ValidTo) : "",
        IsActive: rowData.IsActive,

        stateID: states.map((s) => String(s.id)),
        SelectedDynamicId: parsedZones.length ? parsedZones : parsedZoneCont,

        blocksSchemes: blocks,

        specificContractorIds: block1.specificContractorIds || [],
        mainBlockContractorPoints: block1.specificContractorPoints || {},
        allContractorSelected: blocks[0]?.allContractorSelected || false,
      },
      () => console.log("STATE READY:", this.state),
    );
  };

  handleMainBlockContractorPointsChange = (id, value) => {
    this.setState((prev) => ({
      mainBlockContractorPoints: {
        ...prev.mainBlockContractorPoints,
        [id]: value,
      },
    }));
  };

  handleMainBlockAutoFillContractorPoints = (value) => {
    const filled = {};
    this.state.specificContractorIds.forEach((c) => {
      filled[c.value] = value;
    });
    this.setState({ mainBlockContractorPoints: filled });
  };

  removeMainBlockContractor = (id) => {
    this.setState((prev) => ({
      specificContractorIds: prev.specificContractorIds.filter(
        (c) => c.value !== id,
      ),
      mainBlockContractorPoints: Object.fromEntries(
        Object.entries(prev.mainBlockContractorPoints).filter(([k]) => k != id),
      ),
    }));
  };

  handleMainBlockAutoFillContractorPoints = (value) => {
    const filled = {};
    this.state.specificContractorIds.forEach((c) => {
      filled[c.value] = value;
    });
    this.setState({ mainBlockContractorPoints: filled });
  };

  removeMainBlockContractor = (id) => {
    this.setState((prev) => ({
      specificContractorIds: prev.specificContractorIds.filter(
        (c) => c.value !== id,
      ),
      mainBlockContractorPoints: Object.fromEntries(
        Object.entries(prev.mainBlockContractorPoints).filter(([k]) => k != id),
      ),
    }));
  };

  handleMainAutoFillContractorPoints = (value) => {
    const fillValue = value === "" ? "" : Number(value);

    this.setState((prev) => {
      const updated = {};

      // Loop through selected contractors
      prev.specificContractorIds.forEach((c) => {
        updated[c.value] = fillValue;
      });

      return {
        mainBlockContractorPoints: updated,
      };
    });
  };

  buildTableRequest = () => {
    const userData = JSON.parse(sessionStorage.getItem("UserData"));
    const userId = userData?.UserId || 0;

    const payload = {
      ...new tableRequest(),
      UserId: userId,
      PageNo: this.tblResponse?.PageNo || 1,
      First: this.tblResponse?.First || 1,
      PageSize: this.tblResponse?.PageSize || 5,
      SortColumn: this.tblResponse?.SortColumn || "CreatedDate",
      SortOrder: this.tblResponse?.SortOrder || "DESC",
      SearchValue: this.tblResponse?.SearchValue || "",
      StateId: this.tblResponse?.StateId || 0,
      CityId: this.tblResponse?.CityId || 0,
      ProductId: this.tblResponse?.ProductId || 0,
      FromDate: this.tblResponse?.FromDate || "",
      ToDate: this.tblResponse?.ToDate || "",
      IsActive: this.tblResponse?.IsActive ?? true,
    };
    return payload;
  };

  submitForm = async (event) => {
    event.preventDefault();
    const selectedRoleId = Number(this.state.loyaltySelectedRoleId || 0);

    const roleName = this.state.loyaltySelectedRoleName || "User";
    // ARCHITECT ONLY
    // if (Number(this.state.loyaltySelectedRoleId) === 11) {
    //   const selectedArchitects = this.state.architectSelectedArchitects || [];
    // if ([11, 12].includes(selectedRoleId)) {
    //   const selectedUsers = this.state.architectSelectedArchitects || [];
    //   // if (!selectedArchitects.length) {
    //   //   this.props.showWarn("Please select at least one User");
    //   //   return;
    //   // }
    //   this.props.showWarn(`Please select at least one ${roleName}`);

    //   const roleUserDetails = selectedArchitects.map((architect) => ({
    //     GroupId: Number(this.state.category || 0),
    //     // RoleId: 11,
    //     RoleId: selectedRoleId,
    //     UserId: Number(architect.value),
    //     ContractorId: Number(
    //       this.state.architectSelectedContractor?.value || 0,
    //     ),
    //     StateId: Number(this.state.architectSelectedContractor?.stateId || 0),
    //     ZoneId: Number(this.state.architectSelectedContractor?.zoneId || 0),
    //     Points: Number(this.state.architectPoints?.[architect.value] || 0),
    //     AllUsers: 0,
    //   }));

    //   const invalidPoints = roleUserDetails.some((x) => Number(x.Points) <= 0);

    //   if (invalidPoints) {
    //     this.props.showWarn("Please enter valid Architect points");
    //     return;
    //   }
    //   const architectPayload = {
    //     SchemeId: Number(this.state.SchemeId || 0),
    //     GroupId: Number(this.state.category || 0),
    //     // RoleId: 11,
    //     RoleId: selectedRoleId,
    //     CreatedBy: Number(this.state.UserId || 0),
    //     RoleUserDetails: roleUserDetails,
    //   };
    //   // SAME SUBMIT FLOW
    //   const isNew = !(this.state.SchemeId > 0);

    //   isNew
    //     ? await this.props.createScheme(architectPayload)
    //     : await this.props.updateScheme(architectPayload);

    //   return;
    // }
    if ([11, 12].includes(selectedRoleId)) {
      // Architect (11) / Carpenter (12) selected users
      const selectedUsers = this.state.architectSelectedArchitects || [];

      // Show warning ONLY when no user is selected
      if (selectedUsers.length === 0) {
        this.props.showWarn(`Please select at least one ${roleName}`);
        return;
      }

      const roleUserDetails = selectedUsers.map((user) => ({
        GroupId: Number(this.state.category || 0),
        RoleId: selectedRoleId,
        UserId: Number(user.value),
        ContractorId: Number(
          this.state.architectSelectedContractor?.value || 0,
        ),
        StateId: Number(this.state.architectSelectedContractor?.stateId || 0),
        ZoneId: Number(this.state.architectSelectedContractor?.zoneId || 0),
        Points: Number(this.state.architectPoints?.[user.value] || 0),
        AllUsers: 0,
      }));

      // Validate points
      const invalidPoints = roleUserDetails.some((user) => user.Points <= 0);

      if (invalidPoints) {
        this.props.showWarn(`Please enter valid ${roleName} points`);
        return;
      }

      const rolePayload = {
        SchemeId: Number(this.state.SchemeId || 0),
        GroupId: Number(this.state.category || 0),
        RoleId: selectedRoleId,
        CreatedBy: Number(this.state.UserId || 0),
        RoleUserDetails: roleUserDetails,
      };

      const isNew = !(this.state.SchemeId > 0);

      if (isNew) {
        await this.props.createScheme(rolePayload);
      } else {
        await this.props.updateScheme(rolePayload);
      }

      return;
    }
    const isNew = !(this.state.SchemeId > 0);

    const toDateOnly = (d) => {
      if (!d) return null;
      const dt = new Date(d);
      return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
    };

    //Prevent update if ValidTo < today
    if (!isNew) {
      const today = toDateOnly(new Date());
      const validTo = toDateOnly(this.state.ValidTo);

      if (validTo && validTo < today) {
        this.props.showWarn(
          "You cannot update a scheme whose Valid To date is earlier than today.",
        );
        return;
      }
    }

    /* -----------------------------------------
     1) Basic Validation
  ----------------------------------------- */
    const errors = this.state.formError || {};
    const isValid = Object.keys(errors).every((key) =>
      this.validateForm(this.state[key], key),
    );
    if (!isValid) {
      this.props.showWarn("Please fill all required fields correctly");
      return;
    }

    /* -----------------------------------------
     2) Helpers
  ----------------------------------------- */
    const toNum = (v) => {
      if (v === null || v === undefined || v === "") return 0;
      if (typeof v === "object" && v.value !== undefined)
        return Number(v.value);
      return Number(v) || 0;
    };

    const getId = (x) => toNum(x?.value ?? x?.CityId ?? x);

    const blocks = Array.isArray(this.state.blocksSchemes)
      ? this.state.blocksSchemes
      : [];

    // Safety for update
    if (!isNew && (!this.state.SchemeId || this.state.SchemeId <= 0)) {
      this.props.showWarn("Invalid update detected. Please reload the scheme.");
      return;
    }

    /* -----------------------------------------
     3) Build BlocksSchemes
  ----------------------------------------- */
    const BlocksSchemes = blocks.map((block, index) => ({
      ...block,
      Zones: (block.SelectedDynamicId || []).map((z) => ({
        CityId: Number(getId(z)),
        //Points: Number(z?.Points || 0),
        Points: parseFloat(Number(z?.Points || 0).toFixed(2)),
      })),
      AllContractor:
        index === 0
          ? this.state.allContractorSelected
            ? 1
            : 0
          : block.allContractorSelected
            ? 1
            : 0,
    }));

    /* -----------------------------------------
     4) Validation (Contractor / Zone Points)
  ----------------------------------------- */
    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i];
      const isAll =
        i === 0
          ? this.state.allContractorSelected
          : block.allContractorSelected;

      if (!isAll) {
        const ctrList =
          i === 0
            ? this.state.specificContractorIds || []
            : block.specificContractorIds || [];

        if (!ctrList.length) {
          this.props.showWarn(
            `Please select contractor or check All Contractor for Block ${i + 1}`,
          );
          return;
        }

        const ctrPoints =
          i === 0
            ? this.state.mainBlockContractorPoints || {}
            : block.specificContractorPoints || {};

        if (ctrList.some((c) => Number(ctrPoints[c.value] || 0) <= 0)) {
          this.props.showWarn(
            `Please enter valid contractor points in Block ${i + 1}`,
          );
          return;
        }
      }

      if (isAll) {
        const invalid = (block.SelectedDynamicId || []).some(
          (z) => Number(z?.Points || 0) <= 0,
        );
        if (invalid) {
          this.props.showWarn("Please enter valid Zone Points (>0)");
          return;
        }
      }
    }

    /* -----------------------------------------
     5) Build Specific Contractors
  ----------------------------------------- */
    const SpecificContractors = [];

    const masterList = (
      this.state.masterContractors?.length
        ? this.state.masterContractors
        : this.props.contractDDL || []
    ).map((m) => ({
      value: Number(m.UserId || m.value),
      label: m.DealerName || m.label,
      city: Number(m.City || m.city),
    }));

    blocks.forEach((block, index) => {
      const blockZones = (block.SelectedDynamicId || [])
        .map((z) => Number(getId(z)))
        .filter(Boolean);

      const contractors =
        index === 0
          ? this.state.specificContractorIds || []
          : block.specificContractorIds || [];

      const pointsMap =
        index === 0
          ? this.state.mainBlockContractorPoints || {}
          : block.specificContractorPoints || {};

      const allFlag =
        index === 0
          ? this.state.allContractorSelected
            ? 1
            : 0
          : block.allContractorSelected
            ? 1
            : 0;

      contractors.forEach((ctr) => {
        const ctrId = Number(ctr.value);
        const points = Number(pointsMap[ctrId] || 0);
        const cityId =
          masterList.find((m) => m.value === ctrId)?.city || blockZones[0];

        SpecificContractors.push({
          UserId: ctrId,
          ContractorId: ctrId,
          StateCont: String(block.state || ""),
          ZoneCont: cityId,
          PointsCont: points,
          AllContractor: allFlag,
        });
      });
    });

    /* -----------------------------------------
     6) Dynamic Ids
  ----------------------------------------- */
    const DynamicIds = (this.state.SelectedDynamicId || []).map((z) => ({
      CityId: Number(getId(z)),
      // Points: Number(z?.Points || 0),
      Points: parseFloat(Number(z?.Points || 0).toFixed(2)),
    }));

    const toSqlDate = (d) => {
      if (!d) return null;

      // already a yyyy-MM-dd string
      if (typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
        return d;
      }

      const dt = new Date(d);
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, "0");
      const day = String(dt.getDate()).padStart(2, "0");

      return `${y}-${m}-${day}`;
    };

    /* -----------------------------------------
     7) Final Payload
  ----------------------------------------- */
    const formData = {
      SchemeId: isNew ? 0 : Number(this.state.SchemeId),
      SchemeName: this.state.SchemeName || "",
      SchemeDesc: this.state.Schemedescription || "",
      SchemeCategory: this.state.SchemeCategory || "",
      // SchemeBeneficiary: "2",
      SchemeBeneficiary: String(selectedRoleId),
      RoleId: selectedRoleId,

      AllContractor:
        selectedRoleId === 2 && this.state.allContractorSelected ? 1 : 0,
      AllDistributor:
        selectedRoleId === 9 && this.state.allContractorSelected ? 1 : 0,
      AllSubdealer:
        selectedRoleId === 10 && this.state.allContractorSelected ? 1 : 0,
      AllArchitect:
        selectedRoleId === 11 && this.state.allContractorSelected ? 1 : 0,

      GroupId: this.state.category || "",
      RoleId: Number(this.state.loyaltySelectedRoleId || 0),
      ValidFrm: toSqlDate(this.state.ValidFrm),
      ValidTo: toSqlDate(this.state.ValidTo),

      IsActive: isNew ? 1 : this.state.IsActive ? 1 : 0,
      LoyaltyPoints: Number(this.state.loyalitypnt || 0),

      DynamicIds,
      BlocksSchemes,
      SpecificContractors,
      // AllContractor: this.state.allContractorSelected ? 1 : 0,
    };

    /* -----------------------------------------
     8) API Call
  ----------------------------------------- */
    isNew
      ? await this.props.createScheme(formData)
      : await this.props.updateScheme(formData);

    /* -----------------------------------------
     9) Refresh UI
  ----------------------------------------- */
    await new Promise((r) => setTimeout(r, 300));
    this.props.onHideShow?.(false);

    if (isNew) {
      // reset only on CREATE
      this.resetForm();
    } else {
      this.setState({ isEditing: false });
    }

    await this.props.fetchApi(this.buildTableRequest());
  };

  buildTableRequest = () => {
    const userData = JSON.parse(sessionStorage.getItem("UserData"));
    const userId = userData?.UserId || 0;

    const payload = {
      ...new tableRequest(),
      UserId: userId,
      PageNo: this.tblResponse?.PageNo || 1,
      First: this.tblResponse?.First || 1,
      PageSize: this.tblResponse?.PageSize || 5,
      SortColumn: this.tblResponse?.SortColumn || "CreatedDate",
      SortOrder: this.tblResponse?.SortOrder || "DESC",
      SearchValue: this.tblResponse?.SearchValue || "",
      StateId: this.tblResponse?.StateId || 0,
      CityId: this.tblResponse?.CityId || 0,
      ProductId: this.tblResponse?.ProductId || 0,
      FromDate: this.tblResponse?.FromDate || "",
      ToDate: this.tblResponse?.ToDate || "",
      IsActive: this.tblResponse?.IsActive ?? true,
    };

    console.log("buildTableRequest payload:", payload);
    return payload;
  };

  resetForm = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + 7);

    this.setState({
      productId: "",
      SchemeId: 0,
      FileName: "",
      SchemeName: "",
      stateID: [],
      Schemedescription: "",
      SchemeCategory: "",
      SelectedDynamicId: [],
      RoleId: "",
      loyaltySelectedRoleId: "",
      loyaltySelectedRoleName: "",
      loyaltyRoleUsers: [],
      loyaltySpecificUsers: [],
      loyaltyUserPoints: {},
      product: "",
      category: "",
      Qty: 0,
      StartDate: today,
      EndDate: endDate,
      FromNo: 0,
      ToNo: 0,
      Status: "",
      loyalitypnt: "",
      ValidFrm: today,
      ValidTo: endDate,
      city: "",
      state: "",
      IsActive: true,
      allContractorSelected: false,
      specificContractorIds: [],
      specificContractorPoints: {},
      specificContractorZones: {},
      specificContractorStates: {},

      // Architect / Carpenter UI reset
      architectPincode: "",
      architectContractors: [],
      architectSelectedContractor: null,
      architectArchitects: [],
      architectSelectedArchitects: [],
      architectPoints: {},
      architectBlocks: [],

      buttonLabel: "Submit",
      formHeading: "Add Loyality Master",

      blocksSchemes: [
        {
          state: "",
          SelectedDynamicId: [],
          cityOptions: [],
          IsActive: true,
          autoFillPoints: false,
          hasAutoFilled: false,
          allContractorSelected: false,
          specificContractorIds: [],
          specificContractorPoints: {},
          specificContractorZones: {},
          specificContractorStates: {},
        },
      ],
      formError: {
        productId: "",
        RoleId: "",
        SchemeName: "",
        category: "",
        ValidFrm: "",
        ValidTo: "",
        product: "",
        loyalitypnt: "",
        city: "",
        state: "",
      },
      currentEditingId: null,
      allZones: [],
      isEditing: true,
    });

    let errors = this.state.formError;
    Object.keys(errors).forEach((key) => {
      errors[key] = "";
    });
  };

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  getLazyLoadingValues1(event) {
    this.setState({ rows1: event.rows, first1: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  onPage(event) {
    this.props.loadingData(true);
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
    }, 250);
  }

  onPage1(event) {
    setTimeout(() => {
      this.getLazyLoadingValues1(event);
    }, 250);
  }

  searchFilter(e) {
    this.props.loadingData(true);
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
  }

  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.props.fetchApi(this.tblResponse);
  }

  onSort1(event) {
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
  }

  onHide() {
    this.props.onHideShow(false);
    this.resetForm();
  }

  openDialog() {
    this.resetForm();
    this.props.onHideShow(true);
    this.setState({
      buttonLabel: "Submit",
      formHeading: "Scheme Master",
      isEditing: true,
    });
  }

  onHidee() {
    this.props.onHideShoww(false);
  }

  openDialogue() {
    this.props.onHideShoww(true);
    this.setState({ buttonLabel: "Submit", formHeadingg: "Available Series" });
  }

  onRowSelect(event) {
    this.setState({
      FromNo: event.data.FromNo,
      ToNo: event.data.ToNo,
      Qty: event.data.ToNo - event.data.FromNo + 1,
    });
    this.onHidee();
  }

  statusBodyTemplate(rowData) {
    if (rowData) {
      return (
        <Checkbox
          disabled
          checked={rowData.IsActive}
          color="primary"
          inputProps={{ "aria-label": "secondary checkbox" }}
        />
      );
    }
  }

  getCurrentDateMMDDYYY() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    today = mm + "/" + dd + "/" + yyyy;
    return today;
  }

  getCurrentDate() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    today = mm + "/" + dd + "/" + yyyy;
    return today;
  }

  onHideError() {
    this.props.onHideShowError(false);
  }

  onSelectState(selectedList, selectedItem) {
    this.setState({
      stateID: [...this.state.stateID, selectedItem],
    });
  }

  onRemoveState(selectedList, removedItem) {
    this.setState({
      stateID: this.state.stateID.filter((id) => id.value != removedItem.value),
    });
  }

  onSelect(selectedList, selectedItem) {
    this.setState({
      SelectedDynamicId: [...this.state.SelectedDynamicId, selectedItem],
    });
  }

  onRemove(selectedList, removedItem) {
    this.setState({
      SelectedDynamicId: this.state.SelectedDynamicId.filter(
        (item) => item.value != removedItem.value,
      ),
    });
  }

  handleDropdownChange = (e) => {
    this.handleChange(e);
    this.getCityList(e, "B", "i");
  };

  LocationSelectAll(e, selectedItem) {
    if (e.target.checked) {
      this.setState({
        SelectedDynamicId: [...this.state.SelectedDynamicId, selectedItem],
      });
    } else {
      this.setState({
        SelectedDynamicId: [],
      });
      this.LocRef.current.resetSelectedValues();
    }
  }

  actionBodyTemplate(rowData) {
    const switchHandleChange = (e) => {
      this.setState({
        switchAction: !rowData.IsActive,
        SchemeId: rowData.SchemeId,
      });
      this.props.onHideShowIsActive(true);
    };

    return (
      <>
        {this.state.IsEdit === true ? (
          <div>
            <Button
              icon="pi pi-pencil"
              onClick={() => this.editMode(rowData)}
            />
          </div>
        ) : null}
      </>
    );
  }

  validateForm(value, name) {
    let errors = this.state.formError;
    let IsValid = true;
    switch (name) {
      case "SchemeName":
        if (value.length < 1) {
          IsValid = false;
          errors.SchemeName = "Please enter Scheme name.";
        } else errors.SchemeName = "";
        break;
      case "category":
        if (value.length < 1) {
          IsValid = false;
          errors.category = "Please select category.";
        } else errors.category = "";
        break;
      case "ValidFrm":
        if (value == null || !(value instanceof Date)) {
          IsValid = false;
          errors.ValidFrm = "Please select from date";
        } else if (
          !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          IsValid = false;
          errors.ValidFrm = "Please enter only date.";
        } else if (
          this.state.SchemeType == 0 &&
          Date.parse(value) < Date.parse(new Date(this.getCurrentDate()))
        ) {
          IsValid = false;
          errors.ValidFrm =
            "From date must be greater than or equal to today date.";
        } else if (
          value instanceof Date &&
          this.state.ValidTo instanceof Date
        ) {
          errors.ValidFrm = null;
          errors.ValidTo = null;
          const startDate = value;
          const endDate = this.state.ValidTo;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            IsValid = false;
            errors.ValidFrm = "From date must be less than to date.";
          }
        } else errors.ValidFrm = null;
        break;
      case "ValidTo":
        if (value == null || !(value instanceof Date)) {
          IsValid = false;
          errors.ValidTo = "Please select to date";
        } else if (
          !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          IsValid = false;
          errors.ValidTo = "Please enter only date.";
        } else if (
          Date.parse(value) < Date.parse(new Date(this.getCurrentDate()))
        ) {
          IsValid = false;
          errors.ValidTo =
            "To date must be greater than or equal to today date.";
        } else if (
          value instanceof Date &&
          this.state.ValidFrm instanceof Date
        ) {
          errors.ValidFrm = null;
          errors.ValidTo = null;
          const startDate = this.state.ValidFrm;
          const endDate = value;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            IsValid = false;
            errors.ValidTo = "To date must be greater than from date.";
          }
        } else errors.ValidTo = null;
        break;
      default:
        break;
    }
    return IsValid;
  }

  getDropValueOfRole() {
    if (
      this.state.allContractorSelected &&
      this.state.specificContractorIds.length > 0
    ) {
      const specificNames = this.state.specificContractorIds
        .map((item) => item.label)
        .join(", ");
      return `All Contractor + ${specificNames}`;
    } else if (this.state.allContractorSelected) {
      return "All Contractor";
    } else if (this.state.specificContractorIds.length > 0) {
      return this.state.specificContractorIds
        .map((item) => item.label)
        .join(", ");
    } else {
      return "No Contractor Selected";
    }
  }

  getDropValueOfSchemeCategory() {
    let SchemeCategoryId = "";
    this.state.SchemeCategoryData.filter((x) => {
      if (x.value === this.state.SchemeCategory) {
        SchemeCategoryId = x.label;
      }
    });
    return SchemeCategoryId;
  }

  submitseries(event) {
    event.preventDefault();
    this.props.onHideShoww(false);
  }

  getStateList(event, type) {
    if (type == "B") {
      this.setState({ country: event.target.value });
      this.props.getStateDDL(event.target.value);
    }
  }

  getCityList = (event, type, flag, index) => {
    return new Promise((resolve) => {
      const selectedState = flag === "i" ? event.target.value : event;
      if (type === "B") {
        const blocks = this.state.blocksSchemes || [];
        if (
          typeof index !== "number" ||
          index < 0 ||
          index >= blocks.length ||
          !blocks[index]
        ) {
          resolve();
          return;
        }
        const currentBlock = blocks[index];
        if (currentBlock.state === selectedState) {
          resolve();
          return;
        }
        this.currentIndex = index;
        const updatedBlocks = [...blocks];
        updatedBlocks[index] = {
          ...currentBlock,
          state: selectedState,
          cityOptions: [],
          SelectedDynamicId: [],
        };
        this.setState({ blocksSchemes: updatedBlocks }, async () => {
          try {
            const cityData = await this.props.getBCityDDL(selectedState);
            const finalBlocks = [...this.state.blocksSchemes];
            if (finalBlocks[index]) {
              const cityOptions = (
                cityData ||
                this.props.UserBCityData ||
                []
              ).map((city) => ({
                label: city.name || city.cityName || city.label,
                value: city.id || city.cityId || city.value,
              }));
              finalBlocks[index] = {
                ...finalBlocks[index],
                cityOptions: cityOptions,
              };
              this.setState({ blocksSchemes: finalBlocks });
            }
            resolve(cityData);
          } catch (error) {
            console.error("Error fetching cities:", error);
            resolve([]);
          }
        });
      } else {
        resolve();
      }
    });
  };

  GetZoneWisePoint = (schemeId) => {
    return new Promise(async (resolve) => {
      await this.props.GetZoneWisePointList(schemeId);
      resolve(this.props.loyaltypoints);
    });
  };

  onChangeDDL(e) {
    if (e.target.name == "product") {
      this.setState({ product: e.target.value });
      if (this.state.RoleId != "") {
        this.getFromNo(e.target.value, "p");
      }
    } else if (e.target.name == "RoleId") {
      this.setState({ RoleId: e.target.value });
      if (this.state.product != "") {
        this.getFromNo(e.target.value, "r");
      }
    }
  }

  handleChange(event) {
    let { name, value } = event.target;
    let errors = this.state.formError;
    switch (name) {
      case "IsActive":
        value = event.target.checked;
        break;
      default:
        break;
    }
    this.validateForm(value, name);
    this.setState({ errors, [name]: value });
  }

  getRoleList(event) {
    this.setState({ UserTypeId: event.target.value });
    this.props.getRoleDDL(event.target.value);
  }

  UpdatedDateTemplate(rowData) {
    if (rowData.UpdatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.UpdatedDate}</Moment>;
    }
  }

  CreatedDateTemplate(rowData) {
    if (rowData.UpdatedDate !== null) {
      return <Moment format="D MMM YYYY">{rowData.CreatedDate}</Moment>;
    }
  }

  renderContractorLinks = (rowData) => {
    if (!rowData?.ZoneCont) return "";

    const list = this.parseZoneContString(rowData.ZoneCont);

    // GROUP BY CITY
    const cityGroups = list.reduce((acc, c) => {
      if (!acc[c.city]) acc[c.city] = [];
      acc[c.city].push(c);
      return acc;
    }, {});

    const uniqueCities = Object.keys(cityGroups);

    return (
      <div>
        {uniqueCities.map((city, index) => (
          <span key={index}>
            <a
              href="#!"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() =>
                this.showCityDetail(cityGroups[city], city, rowData.RoleName)
              }
            >
              {city}
            </a>
            {index < uniqueCities.length - 1 ? ", " : ""}
          </span>
        ))}
      </div>
    );
  };

  showCityDetail = (contractorList, city, roleName) => {
    this.setState({
      selectedCity: city,
      selectedCityContractors: contractorList,
      selectedCityRoleName: roleName || "User",
      showContractorPopup: true,
    });
  };

  showContractorDetail = (contractor) => {
    this.setState({
      selectedContractor: contractor,
      showContractorPopup: true,
    });
  };

  parseZone = (zoneStr) => {
    const cityMatch = zoneStr.match(/^(.+?)\s*\(/);
    const stateMatch = zoneStr.match(/\((.*?)\)/);
    // const pointsMatch = zoneStr.match(/-\s*(\d+)/);
    const pointsMatch = zoneStr.match(/-\s*(\d+(?:\.\d+)?)/);

    return {
      city: cityMatch ? cityMatch[1].trim() : "",
      state: stateMatch ? stateMatch[1].trim() : "",
      points: pointsMatch ? pointsMatch[1].trim() : "0",
    };
  };

  isExpiredBenefit = () => {
    const { ValidTo } = this.state;

    if (!ValidTo) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const eDate = new Date(ValidTo);
    eDate.setHours(0, 0, 0, 0);

    return eDate < today;
  };

  isArchitectRole = () => Number(this.state.loyaltySelectedRoleId) === 11;

  isCarpenterRole = () => Number(this.state.loyaltySelectedRoleId) === 12;

  isArchitectOrCarpenterRole = () =>
    this.isArchitectRole() || this.isCarpenterRole();

  getRoleUsersBySelectedCities = (selectedCities = []) => {
    if (!selectedCities.length) {
      return [];
    }

    const selectedCityNames = new Set(
      selectedCities
        .map((city) =>
          String(city.CityName ?? city.cityName ?? city.label ?? "")
            .trim()
            .toLowerCase(),
        )
        .filter(Boolean),
    );

    return (this.state.loyaltyRoleUsers || []).filter((user) =>
      selectedCityNames.has(user.city),
    );
  };

  handleLoyaltyUserRoleChange = async (e) => {
    const roleId = e.value;
    const isArchitect = Number(roleId) === 11;
    const isCarpenter = Number(roleId) === 12;

    const selectedRole = (this.props.UserRoleData || []).find(
      (role) => String(role.value) === String(roleId),
    );
    const roleName = selectedRole?.label || "";

    // Reset role user section
    this.setState({
      loyaltySelectedRoleId: roleId || "",
      loyaltySelectedRoleName: roleName,

      loyaltyRoleUsers: [],
      loyaltySpecificUsers: [],
      loyaltyUserPoints: {},

      // Architect reset
      architectPincode: "",
      architectContractors: [],
      architectSelectedContractor: null,
    });

    if (!roleId || this.isArchitectOrCarpenterRole()) {
      return;
    }

    // ==========================================
    // CONTRACTOR / DISTRIBUTOR OLD FLOW
    // ==========================================
    try {
      const users = await this.props.getDlrArctDistUsers(roleId);
      const formattedUsers = (users || []).map((user) => ({
        value: Number(user.UserId),
        label: user.UserName,
        roleId: Number(user.RoleId),
        city: (user.City || "").trim().toLowerCase(),
      }));

      this.setState({
        loyaltyRoleUsers: formattedUsers,
      });
    } catch (error) {
      console.error("Error loading role users:", error);

      this.setState({
        loyaltyRoleUsers: [],
      });
    }
  };

  // ARCHITECT ONLY - FRESH FLOW

  handleArchitectPincodeChange = async (e) => {
    const pincode = e.target.value;

    this.setState({
      architectPincode: pincode,
      architectContractors: [],
      architectSelectedContractor: null,
      architectArchitects: [],
      architectSelectedArchitects: [],
      architectPoints: {},
    });

    // Only call API for complete 10 digit pincode
    if (!pincode || pincode.length !== 10) {
      return;
    }

    try {
      const contractors = await this.props.getContractorsByPincode(pincode);

      // const formattedContractors = (contractors || []).map((item) => ({
      //   value: Number(item.Value ?? item.value),
      //   label: item.Label ?? item.label,
      // }));
      const formattedContractors = (contractors || []).map((item) => ({
        value: Number(item.Value ?? item.value),

        label: item.Label ?? item.label ?? item.DealerName ?? item.UserName,

        stateId: Number(item.StateId ?? item.stateId ?? 0),

        zoneId: Number(item.ZoneId ?? item.zoneId ?? 0),
      }));

      this.setState({
        architectContractors: formattedContractors,
      });
    } catch (error) {
      console.error("Error loading Architect contractors:", error);

      this.setState({
        architectContractors: [],
      });
    }
  };

  handleArchitectContractorChange = async (e) => {
    const contractorId = e.value;

    const selectedContractor = this.state.architectContractors.find(
      (item) => Number(item.value) === Number(contractorId),
    );

    this.setState({
      architectSelectedContractor: selectedContractor || null,

      architectArchitects: [],
      architectSelectedArchitects: [],
      architectPoints: {},
    });

    if (!contractorId) {
      return;
    }

    try {
      const roleId = Number(this.state.loyaltySelectedRoleId);

      if (![11, 12].includes(roleId)) {
        console.error("Invalid RoleId:", roleId);
        return;
      }

      const architects = await this.props.getArchitectsByContractor(
        contractorId,
        roleId,
      );
      // const architects = await this.props.getArchitectsByContractor(contractorId);

      const formattedArchitects = (architects || []).map((item) => ({
        value: Number(item.Value ?? item.value ?? item.UserId),

        label: item.Label ?? item.label ?? item.UserName,

        roleId: roleId,
      }));

      this.setState({
        architectArchitects: formattedArchitects,
      });
    } catch (error) {
      console.error("Error loading Architects:", error);

      this.setState({
        architectArchitects: [],
      });
    }
  };

  handleArchitectSelection = (selectedList) => {
    const newPoints = {
      ...this.state.architectPoints,
    };

    selectedList.forEach((architect) => {
      if (newPoints[architect.value] === undefined) {
        newPoints[architect.value] = 0;
      }
    });

    // Remove points of removed architects
    Object.keys(newPoints).forEach((id) => {
      const exists = selectedList.some(
        (architect) => String(architect.value) === String(id),
      );

      if (!exists) {
        delete newPoints[id];
      }
    });

    this.setState({
      architectSelectedArchitects: selectedList,
      architectPoints: newPoints,
    });
  };

  // handleArchitectPointsChange = (architectId, points) => {
  //   this.setState({
  //     architectPoints: {
  //       ...this.state.architectPoints,
  //       [architectId]: parseInt(points),
  //     },
  //   });
  // };

  handleArchitectPointsChange = (key, value) => {
    this.setState({
      architectPoints: {
        ...this.state.architectPoints,
        [key]: value === "" ? "" : value,
      },
    });
  };

  // =====================================================
  // ARCHITECT BLOCK FLOW
  // =====================================================

  handleArchitectBlockPincodeChange = async (e, blockIndex) => {
    const pincode = e.target.value;

    const architectBlocks = [...this.state.architectBlocks];

    architectBlocks[blockIndex] = {
      ...architectBlocks[blockIndex],
      pincode,
      contractors: [],
      selectedContractor: null,
      architects: [],
      selectedArchitects: [],
      points: {},
    };

    this.setState({ architectBlocks });

    if (!pincode || pincode.length !== 10) {
      return;
    }

    try {
      const contractors = await this.props.getContractorsByPincode(pincode);

      const formattedContractors = (contractors || []).map((item) => ({
        value: Number(item.Value ?? item.value),
        label: item.Label ?? item.label,

        stateId: Number(item.StateId ?? item.stateId ?? 0),
        zoneId: Number(item.ZoneId ?? item.zoneId ?? 0),
      }));
      const updatedBlocks = [...this.state.architectBlocks];

      updatedBlocks[blockIndex] = {
        ...updatedBlocks[blockIndex],
        contractors: formattedContractors,
      };

      this.setState({
        architectBlocks: updatedBlocks,
      });
    } catch (error) {
      console.error("Error loading Architect block contractors:", error);
    }
  };

  handleArchitectBlockContractorChange = async (e, blockIndex) => {
    const contractorId = e.value;

    const architectBlocks = [...this.state.architectBlocks];

    const block = architectBlocks[blockIndex];

    const selectedContractor = (block.contractors || []).find(
      (c) => Number(c.value) === Number(contractorId),
    );

    architectBlocks[blockIndex] = {
      ...block,
      selectedContractor: selectedContractor || null,

      stateId: Number(selectedContractor?.stateId || 0),
      zoneId: Number(selectedContractor?.zoneId || 0),

      architects: [],
      selectedArchitects: [],
      points: {},
    };

    this.setState({
      architectBlocks,
    });

    if (!contractorId) {
      return;
    }

    try {
      const roleId = Number(this.state.loyaltySelectedRoleId);
      const architects = await this.props.getArchitectsByContractor(
        contractorId,
        roleId,
      );

      const formattedArchitects = (architects || []).map((item) => ({
        value: Number(item.Value ?? item.value ?? item.UserId),
        label: item.Label ?? item.label ?? item.UserName,
        roleId: roleId,
      }));

      const updatedBlocks = [...this.state.architectBlocks];

      updatedBlocks[blockIndex] = {
        ...updatedBlocks[blockIndex],
        architects: formattedArchitects,
      };

      this.setState({
        architectBlocks: updatedBlocks,
      });
    } catch (error) {
      console.error("Error loading Architect block users:", error);
    }
  };

  handleArchitectBlockSelection = (selectedList, blockIndex) => {
    const architectBlocks = [...this.state.architectBlocks];

    const block = architectBlocks[blockIndex];

    const newPoints = {
      ...(block.points || {}),
    };

    selectedList.forEach((architect) => {
      if (newPoints[architect.value] === undefined) {
        newPoints[architect.value] = 0;
      }
    });

    Object.keys(newPoints).forEach((id) => {
      const exists = selectedList.some(
        (architect) => String(architect.value) === String(id),
      );

      if (!exists) {
        delete newPoints[id];
      }
    });

    architectBlocks[blockIndex] = {
      ...block,
      selectedArchitects: selectedList,
      points: newPoints,
    };

    this.setState({
      architectBlocks,
    });
  };

  handleArchitectBlockPointsChange = (architectId, points, blockIndex) => {
    const architectBlocks = [...this.state.architectBlocks];

    const block = architectBlocks[blockIndex];

    architectBlocks[blockIndex] = {
      ...block,
      points: {
        ...(block.points || {}),
        [architectId]: parseInt(points) || 0,
      },
    };

    this.setState({
      architectBlocks,
    });
  };

  render() {
    const isExpired = this.isExpiredBenefit();
    const isArchitect = Number(this.state.loyaltySelectedRoleId) === 11;
    const isArchitectOrCarpenter = this.isArchitectOrCarpenterRole();

    const renderFooter = () => {
      return (
        <div>
          <Button
            label="No"
            icon="pi pi-times"
            onClick={() => this.props.onHideShowIsActive(false)}
            className="p-button-text"
          />
          <Button
            label="Yes"
            icon="pi pi-check"
            onClick={() => this.switchToggleConfirm()}
            autoFocus
          />
        </div>
      );
    };

    const header = (
      <div className="table-header row my-3">
        <div className="col-md-4 master_headhingcol">
          <h4>Loyalty Scheme Master</h4>
        </div>
        <div className="col-md-8 layoutright">
          <span className="p-input-icon-left mr-2">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={(e) => this.searchFilter(e)}
              placeholder="Global Search"
            />
          </span>
          {this.state.IsAdd === true ? (
            <Button
              className="mr-2"
              label="Add Scheme"
              icon="pi pi-plus-circle"
              onClick={this.openDialog}
            />
          ) : (
            <Button
              className="mr-2"
              label="Add Scheme"
              icon="pi pi-plus-circle"
              style={{ display: "none" }}
              onClick={this.openDialog}
            />
          )}
        </div>
      </div>
    );

    return (
      <div className="datatable-filter-demo">
        <ToastContainer />
        <div className="card mb-5">
          <DataTable
            className="mb-2"
            value={this.props.SchememappingData}
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            header={header}
            emptyMessage="No data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[5, 10, 20, parseInt(this.state.totalRecords)]}
            totalRecords={parseInt(this.state.totalRecords)}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.props.loading}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column field="SchemeName" header="Scheme Name" sortable></Column>
            <Column field="RoleName" header="Role Name" sortable />
            <Column field="GroupName" header="Group Name" sortable></Column>
            <Column
              field="ValidFrm"
              header="Valid From"
              sortable
              body={(rowData) => {
                if (!rowData || !rowData.ValidFrm) return "";
                const date = new Date(rowData.ValidFrm);
                if (isNaN(date)) return "";
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
              }}
            />

            <Column
              field="ValidTo"
              header="Valid To"
              sortable
              body={(rowData) => {
                if (!rowData || !rowData.ValidTo) return ""; // ✅ added rowData check
                const date = new Date(rowData.ValidTo);
                if (isNaN(date)) return "";
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
              }}
            />

            <Column
              header="City"
              body={(rowData) => {
                if (!rowData || !rowData.Zones) return "-";

                // Split zones
                const zonesArr = rowData.Zones.split(",")
                  .map((z) => z.trim())
                  .filter(Boolean);

                // Parse + remove zones with 0 points
                const validZones = zonesArr
                  .map((z) => this.parseZone(z))
                  .filter((z) => Number(z.points) > 0);

                if (!validZones.length) return "-";

                // Rebuild display strings
                const displayZones = validZones.map(
                  (z) => `${z.city} (${z.state}) - ${z.points}`,
                );

                if (displayZones.length === 1) {
                  return displayZones[0];
                }

                return (
                  <span>
                    {displayZones[0]}{" "}
                    <a
                      href="#!"
                      style={{ marginLeft: "4px", fontWeight: "bold" }}
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({
                          showZonePopup: true,
                          selectedZoneDetails: displayZones,
                        });
                      }}
                    >
                      …
                    </a>
                  </span>
                );
              }}
            />

            <Column
              field="ZoneCont"
              header="Specific City"
              sortable
              body={(rowData) => this.renderContractorLinks(rowData)}
            />
            <Column
              header={
                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <span>Is Active</span>
                </div>
              }
              body={(rowData) => (
                <Checkbox
                  checked={rowData?.IsActive == 1}
                  onChange={(e) =>
                    this.toggleRowIsActive(rowData, e.target.checked)
                  }
                  color="primary"
                  disabled={!rowData} // prevent click on null row
                />
              )}
              style={{ width: "140px", textAlign: "center" }}
            />

            {this.state.IsEdit === true ? (
              <Column
                className="text-right"
                field="Action"
                header="Action"
                style={{ width: "100px" }}
                body={this.actionBodyTemplate}
              ></Column>
            ) : (
              <Column
                field="Action"
                header="Action"
                style={{ width: "120px", display: "none" }}
              ></Column>
            )}
          </DataTable>
        </div>

        <div className="card">
          <h3 style={{ marginBottom: "30px", marginTop: "15px" }}>
            Loyalty Points for Architect and Carpenter
          </h3>

          <DataTable
            value={this.props.archiCarpenterList || []}
            paginator
            lazy
            rows={this.state.rows}
            first={this.state.first}
            totalRecords={this.props.totalRecords || this.state.totalRecords}
            onPage={this.onPageArchiCarpenter}
            onSort={this.onSortArchiCarpenter}
            sortField={this.state.sortField}
            sortOrder={this.state.sortOrder}
            globalFilter={this.state.globalFilter}
            emptyMessage="No loyalty schemes found."
            responsiveLayout="scroll"
            className="p-datatable-striped p-datatable-gridlines"
          >
            <Column field="RoleName" header="Role Name" sortable />
            <Column field="ContractorName" header="Contractor Name" sortable />

            <Column
              field="ArchitectName"
              header="Architect"
              body={this.architectBodyTemplate}
              sortable
            />

            <Column
              field="CarpenterName"
              header="Carpenter"
              body={this.carpenterBodyTemplate}
              sortable
            />

            <Column field="Points" header="Points" sortable />

            <Column
              field="IsActive"
              header="Is Active"
              body={this.statusBodyTemplate}
              style={{ textAlign: "center" }}
            />
          </DataTable>
        </div>

        {/* Ensure in your constructor (or component initialization) you have:
   
*/}

        <Dialog
          key={this.state.currentEditingId || "new"}
          header={this.state.formHeading}
          modal
          dismissableMask={false}
          visible={this.props.showDialog}
          className="popup"
          onHide={this.onHide}
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 pt-3">
                <Dropdown
                  value={this.state.loyaltySelectedRoleId}
                  options={this.props.loyaltyRoleDropdownData || []}
                  optionLabel="label"
                  optionValue="value"
                  onChange={this.handleLoyaltyUserRoleChange}
                  placeholder="Select User Role"
                  disabled={
                    !this.state.isEditing || this.state.currentEditingId != null
                  }
                  filter
                  className="form-control custom-select"
                  appendTo={document.getElementById("root")}
                />
              </div>
              {/* BASIC FORM FIELDS */}
              {!isArchitectOrCarpenter && (
                <div className="col-md-4 pt-3">
                  <TextField
                    disabled={!this.state.isEditing}
                    onChange={this.handleChange}
                    name="SchemeName"
                    value={this.state.SchemeName}
                    size="small"
                    variant="outlined"
                    className="fullwidth"
                    label="Scheme Name*"
                  />
                  {this.state.formError.SchemeName && (
                    <div className="error">
                      {this.state.formError.SchemeName}
                    </div>
                  )}
                </div>
              )}
              {!isArchitectOrCarpenter && (
                <div className="col-md-4 pt-3">
                  {/* <Dropdown
                  disabled={!this.state.isEditing}
                  onChange={this.handleChange}
                  name="category"
                  options={this.props.CategoryDDL}
                  optionLabel="label"
                  optionValue="value"
                  value={this.state.category}
                  filter
                  className="form-control custom-select"
                  placeholder="Select Group*"
                /> */}

                  <Dropdown
                    disabled={this.state.currentEditingId != null}
                    onChange={this.handleChange}
                    name="category"
                    options={this.props.CategoryDDL}
                    optionLabel="label"
                    optionValue="value"
                    value={this.state.category}
                    filter
                    className="form-control custom-select"
                    placeholder="Select Group*"
                  />

                  {this.state.formError.category && (
                    <div className="error">{this.state.formError.category}</div>
                  )}
                </div>
              )}

              {!isArchitectOrCarpenter && (
                <>
                  {/* DATE RANGE */}
                  <div className="col-md-2 pt-3 text-right">
                    <label>
                      Valid From<span>*</span>:
                    </label>
                  </div>
                  <div className="col-md-4 pt-3">
                    <Calendar
                      value={this.state.ValidFrm}
                      onChange={this.handleChange}
                      name="ValidFrm"
                      showIcon
                      disabled={!this.state.isEditing || isExpired}
                      appendTo={document.getElementById("root")}
                    />

                    {this.state.formError.ValidFrm && (
                      <div className="error">
                        {this.state.formError.ValidFrm}
                      </div>
                    )}
                  </div>
                </>
              )}

              {!isArchitectOrCarpenter && (
                <>
                  <div className="col-md-2 pt-3 text-right">
                    <label>
                      Valid To<span>*</span>:
                    </label>
                  </div>
                  <div className="col-md-4 pt-3">
                    <Calendar
                      value={this.state.ValidTo}
                      onChange={this.handleChange}
                      name="ValidTo"
                      showIcon
                      minDate={this.state.ValidFrm}
                      disabled={!this.state.isEditing || isExpired}
                      appendTo={document.getElementById("root")}
                    />

                    {this.state.formError.ValidTo && (
                      <div className="error">
                        {this.state.formError.ValidTo}
                      </div>
                    )}
                  </div>
                </>
              )}

              {/* ---------------------------- */}
              {/* BLOCKS SECTION (ITERATED)     */}
              {/* ---------------------------- */}

              {(this.state.blocksSchemes || []).map((block, index) =>
                block ? (
                  <div
                    key={index}
                    className="row border p-3 mb-3 w-100 mx-0 mt-3"
                  >
                    {/* -------- Block Heading -------- */}
                    <div className="col-md-12 mb-2">
                      <h6 className="text-primary">Block {index + 1}</h6>
                    </div>
                    {!isArchitectOrCarpenter && (
                      <div className="col-md-12">
                        <div className="row">
                          {/* 1. State for Block (Left Side) */}
                          <div className="col-md-6 pt-3 mt-235">
                            <FormControl
                              variant="outlined"
                              size="small"
                              className="formControl w-100"
                            >
                              <label className="dropdown-label mb-2">
                                <strong>State for Block {index + 1}*</strong>
                              </label>
                              <Dropdown
                                disabled={!this.state.isEditing}
                                appendTo={document.getElementById("root")}
                                value={block.state}
                                options={this.props.StateData}
                                onChange={(e) =>
                                  this.handleBlockStateChange(e, index)
                                }
                                optionValue="value"
                                optionLabel="label"
                                className="form-control custom-select"
                                placeholder="Select State*"
                                name="state"
                                filter
                              />
                            </FormControl>
                          </div>

                          {/* 2. City Dropdown with "Select All Cities" as Label (Right Side) */}
                          <div className="col-md-6 pt-3">
                            <FormControl
                              variant="outlined"
                              size="small"
                              className="w-100"
                            >
                              {/* Label ki jagah par Select All Cities checkbox */}
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        (block.SelectedDynamicId?.length ||
                                          0) ===
                                          (block.cityOptions?.length || 0) &&
                                        block.cityOptions?.length > 0
                                      }
                                      indeterminate={
                                        block.SelectedDynamicId?.length > 0 &&
                                        block.SelectedDynamicId?.length <
                                          block.cityOptions?.length
                                      }
                                      onChange={(e) =>
                                        this.handleBlockSelectAll(e, index)
                                      }
                                      disabled={
                                        !this.state.isEditing ||
                                        !block.cityOptions ||
                                        block.cityOptions.length === 0
                                      }
                                      color="primary"
                                      size="small"
                                      style={{ padding: "0 6px 0 0" }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "0.9rem",
                                      }}
                                    >
                                      Select All Cities
                                    </span>
                                  }
                                  style={{ margin: 0 }}
                                />

                                {/* Selected count info right side me */}
                                <small
                                  className="text-muted"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  ({block.SelectedDynamicId?.length || 0} of{" "}
                                  {block.cityOptions?.length || 0} selected)
                                </small>
                              </div>

                              {/* City Multiselect dropdown */}
                              <div className="w-100">
                                <Multiselect
                                  key={`cities-${index}-${block.state}-${(block.cityOptions || []).length}-${block.SelectedDynamicId?.length}`}
                                  displayValue="label"
                                  selectedValues={block.SelectedDynamicId || []}
                                  onSelect={(list, item) =>
                                    this.handleBlockZoneSelection(
                                      list,
                                      item,
                                      index,
                                    )
                                  }
                                  onRemove={(list, item) =>
                                    this.handleBlockZoneRemove(
                                      list,
                                      item,
                                      index,
                                    )
                                  }
                                  options={block.cityOptions || []}
                                  placeholder={
                                    block.cityOptions?.length > 0
                                      ? "Select City*"
                                      : block.state
                                        ? "Select City*"
                                        : "Select City*"
                                  }
                                  disabled={
                                    !this.state.isEditing || !block.state
                                  }
                                  closeOnSelect={false}
                                  style={{
                                    chips: {
                                      background: "#007ad9",
                                      margin: "2px",
                                    },
                                    searchBox: {
                                      border: "1px solid #ced4da",
                                      borderRadius: "4px",
                                      padding: "5px 8px",
                                      minHeight: "38px",
                                    },
                                  }}
                                />
                              </div>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* -------- NEW ROW 2: All Contractors (for blocks index >= 1) -------- */}
                    {index >= 1 && (
                      <div className="col-md-12 mt-2">
                        <FormControlLabel
                          style={{ marginLeft: "0px" }}
                          control={
                            <Checkbox
                              checked={block.allContractorSelected || false}
                              onChange={(e) =>
                                this.handleBlockAllContractorChange(e, index)
                              }
                              color="primary"
                              disabled={!this.state.isEditing}
                            />
                          }
                          label={
                            <span>
                              {/* <strong>All Contractors</strong> */}
                              <strong>
                                All{" "}
                                {this.state.loyaltySelectedRoleName || "User"}
                              </strong>
                              <small className="text-muted d-block">
                                Override city selection
                              </small>
                            </span>
                          }
                        />
                      </div>
                    )}

                    {/* ============================= */}
                    {/* MAIN CONTRACTOR SECTION (Index 0) */}
                    {/* ============================= */}
                    {index === 0 && (
                      <div className="col-md-12 pt-4">
                        {this.isArchitectOrCarpenterRole() ? (
                          // ARCHITECT FRESH FLOW
                          <div className="contractor-selection-section">
                            {/* <h5>Architect Selection</h5> */}
                            <h5>
                              {this.state.loyaltySelectedRoleName} Selection
                            </h5>
                            <div className="row">
                              {/* PINCODE */}
                              <div className="col-md-4 pt-3">
                                <FormControl
                                  variant="outlined"
                                  size="small"
                                  className="formControl col-md-12"
                                >
                                  <label className="dropdown-label">
                                    <strong>MobileNo.</strong>
                                  </label>

                                  <TextField
                                    variant="outlined"
                                    size="small"
                                    value={this.state.architectPincode}
                                    onChange={this.handleArchitectPincodeChange}
                                    inputProps={{
                                      maxLength: 10,
                                    }}
                                    disabled={!this.state.isEditing}
                                    placeholder="Enter MobileNo."
                                    fullWidth
                                  />
                                </FormControl>
                              </div>

                              {/* ========================= */}
                              {/* CONTRACTOR */}
                              {/* ========================= */}
                              <div className="col-md-4 pt-3">
                                <FormControl
                                  variant="outlined"
                                  size="small"
                                  className="formControl col-md-12"
                                >
                                  <label className="dropdown-label">
                                    <strong>Contractor</strong>
                                  </label>

                                  <Dropdown
                                    value={
                                      this.state.architectSelectedContractor
                                        ?.value || null
                                    }
                                    options={
                                      this.state.architectContractors || []
                                    }
                                    optionLabel="label"
                                    optionValue="value"
                                    onChange={
                                      this.handleArchitectContractorChange
                                    }
                                    placeholder="Select Contractor"
                                    disabled={
                                      !this.state.isEditing ||
                                      !this.state.architectPincode ||
                                      this.state.architectPincode.length !== 10
                                    }
                                    filter
                                    showClear
                                    className="form-control custom-select"
                                    appendTo={document.getElementById("root")}
                                  />
                                </FormControl>
                              </div>

                              {/* ========================= */}
                              {/* ARCHITECT MULTISELECT */}
                              {/* ========================= */}
                              <div className="col-md-4 pt-3">
                                <FormControl
                                  variant="outlined"
                                  size="small"
                                  className="formControl col-md-12"
                                >
                                  <label className="dropdown-label">
                                    <strong>
                                      {this.state.loyaltySelectedRoleName ||
                                        "User"}
                                    </strong>
                                  </label>

                                  <Multiselect
                                    selectedValues={
                                      this.state.architectSelectedArchitects ||
                                      []
                                    }
                                    options={
                                      this.state.architectArchitects || []
                                    }
                                    displayValue="label"
                                    onSelect={this.handleArchitectSelection}
                                    onRemove={this.handleArchitectSelection}
                                    placeholder={`Select ${this.state.loyaltySelectedRoleName || "User"}`}
                                    disable={
                                      !this.state.isEditing ||
                                      !this.state.architectSelectedContractor
                                    }
                                    showCheckbox={true}
                                    avoidHighlightFirstOption
                                    closeOnSelect={false}
                                  />
                                </FormControl>
                              </div>
                            </div>

                            {/* ================================= */}
                            {/* ARCHITECT POINT DISTRIBUTION */}
                            {/* ================================= */}

                            {this.state.architectSelectedArchitects?.length >
                              0 && (
                              <div className="col-md-12 mt-4">
                                <FormControl
                                  variant="outlined"
                                  size="small"
                                  className="formControl col-md-12"
                                >
                                  <label className="dropdown-label">
                                    <strong>
                                      Point Distribution for{" "}
                                      {this.state.loyaltySelectedRoleName ||
                                        "User"}
                                    </strong>
                                  </label>

                                  <DataTable
                                    value={
                                      this.state.architectSelectedArchitects
                                    }
                                    className="p-datatable-sm"
                                  >
                                    <Column
                                      field="label"
                                      header={
                                        this.state.loyaltySelectedRoleName ||
                                        "User"
                                      }
                                    />

                                    <Column
                                      header="Points"
                                      body={(rowData) => (
                                        <InputText
                                          type="number"
                                          min="0.01"
                                          step="0.01"
                                          value={
                                            this.state.architectPoints?.[
                                              rowData.value
                                            ] ?? ""
                                          }
                                          onChange={(e) =>
                                            this.handleArchitectPointsChange(
                                              rowData.value,
                                              e.target.value,
                                            )
                                          }
                                          disabled={!this.state.isEditing}
                                          style={{
                                            width: "120px",
                                          }}
                                        />
                                      )}
                                    />
                                  </DataTable>
                                </FormControl>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="contractor-selection-section">
                            {/* <h5>Specific Contractor Selection</h5> */}
                            <h5>
                              Specific{" "}
                              {this.state.loyaltySelectedRoleName || "User"}{" "}
                              Selection
                            </h5>

                            <div className="row">
                              {/* All Contractor Checkbox (Main Block only) */}
                              <div className="col-md-12 mb-3">
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.allContractorSelected}
                                      onChange={this.handleAllContractorChange}
                                      name="allContractorSelected"
                                      color="primary"
                                      disabled={!this.state.isEditing}
                                    />
                                  }
                                  label={
                                    <span>
                                      {/* <strong>All Contractor</strong>
                                    <small className="text-muted d-block">
                                      Apply loyalty points to all contractors
                                    </small> */}
                                      <strong>
                                        All{" "}
                                        {this.state.loyaltySelectedRoleName ||
                                          "User"}
                                      </strong>

                                      <small className="text-muted d-block">
                                        Apply loyalty points to all{" "}
                                        {(
                                          this.state.loyaltySelectedRoleName ||
                                          "users"
                                        ).toLowerCase()}
                                      </small>
                                    </span>
                                  }
                                />
                              </div>

                              {/* Specific Contractor Multiselect */}
                              <div className="col-md-12">
                                <FormControl
                                  variant="outlined"
                                  size="small"
                                  className="formControl col-md-12"
                                >
                                  <label className="dropdown-label">
                                    {/* <strong>Specific Contractors</strong> */}
                                    <strong>
                                      Specific{" "}
                                      {this.state.loyaltySelectedRoleName ||
                                        "User"}{" "}
                                    </strong>
                                  </label>

                                  <Multiselect
                                    key={`main-contractors-${this.state.currentEditingId || "new"}-${(this.state.specificContractorIds || []).length}`}
                                    displayValue="label"
                                    selectedValues={
                                      this.state.specificContractorIds || []
                                    }
                                    onSelect={(list) =>
                                      this.handleMainSpecificContractorChange(
                                        list,
                                      )
                                    }
                                    onRemove={(list, item) =>
                                      this.handleMainSpecificContractorRemove(
                                        list,
                                        item,
                                      )
                                    }
                                    // options={this.getFilteredContractors(
                                    //   block.SelectedDynamicId,
                                    // )}
                                    // options={this.state.loyaltyRoleUsers || []}
                                    options={this.getRoleUsersBySelectedCities(
                                      this.state.blocksSchemes[0]
                                        ?.SelectedDynamicId || [],
                                    )}
                                    // placeholder="Select specific contractors..."
                                    placeholder={`Select specific ${(
                                      this.state.loyaltySelectedRoleName ||
                                      "users"
                                    ).toLowerCase()}`}
                                    disabled={
                                      !this.state.isEditing ||
                                      this.state.allContractorSelected
                                    }
                                    closeOnSelect={false}
                                  />
                                </FormControl>
                              </div>
                            </div>

                            {(this.state.specificContractorIds?.length > 0 ||
                              this.state.allContractorSelected) && (
                              <div className="col-md-12 pt-4">
                                <div className="block-contractor-points-section">
                                  {/* <h6>Main Contractor Points</h6> */}
                                  <h6>
                                    Main{" "}
                                    {this.state.loyaltySelectedRoleName ||
                                      "User"}{" "}
                                    Points
                                  </h6>

                                  <div className="auto-fill-section mb-3">
                                    <div className="row">
                                      <div className="col-md-4">
                                        <TextField
                                          size="small"
                                          variant="outlined"
                                          placeholder="Enter points for all"
                                          inputRef={(el) =>
                                            (this.mainAutoFillInput = el)
                                          }
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              this.handleMainAutoFillContractorPoints(
                                                e.target.value,
                                              );
                                            }
                                          }}
                                          disabled={!this.state.isEditing}
                                        />
                                      </div>

                                      <div className="col-md-4">
                                        <Button
                                          label="Auto Fill Points"
                                          className="p-button-success p-button-sm"
                                          onClick={() => {
                                            if (this.mainAutoFillInput) {
                                              this.handleMainAutoFillContractorPoints(
                                                this.mainAutoFillInput.value,
                                              );
                                            }
                                          }}
                                          disabled={!this.state.isEditing}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <DataTable
                                    value={this.state.specificContractorIds}
                                    className="p-datatable-sm"
                                  >
                                    {/* <Column
                                    header="Contractor Name"
                                    body={(row) =>
                                      row?.label || row?.contractorName
                                    }
                                    style={{ width: "30%" }}
                                  /> */}
                                    <Column
                                      header={`${this.state.loyaltySelectedRoleName || "User"} Name`}
                                      body={(row) =>
                                        row?.label || row?.contractorName
                                      }
                                      style={{ width: "30%" }}
                                    />

                                    <Column
                                      header="Points*"
                                      body={(row) => (
                                        <input
                                          type="number"
                                          min="1"
                                          step="0.01"
                                          value={
                                            this.state
                                              .mainBlockContractorPoints?.[
                                              row.value
                                            ] || ""
                                          }
                                          onChange={(e) =>
                                            this.handleMainBlockContractorPointsChange(
                                              row.value,
                                              e.target.value,
                                            )
                                          }
                                          disabled={!this.state.isEditing}
                                          className="form-control"
                                          style={{ width: "120px" }}
                                        />
                                      )}
                                    />

                                    <Column
                                      header="Action"
                                      body={(row) => (
                                        <Button
                                          icon="pi pi-times"
                                          className="p-button-danger p-button-sm"
                                          onClick={() =>
                                            this.confirmDeleteMainContractor(
                                              row.value,
                                            )
                                          }
                                          disabled={!this.state.isEditing}
                                        />
                                      )}
                                    />
                                  </DataTable>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    {index >= 1 && (
                      <>
                        {this.isArchitectOrCarpenterRole() ? (
                          <>
                            {(() => {
                              const architectIndex = index - 1;
                              return (
                                <>
                                  <div className="col-md-12 pt-3">
                                    <div className="block-contractor-selection-section">
                                      <h6>
                                        {this.state.loyaltySelectedRoleName ||
                                          "User"}{" "}
                                        Selection for Block
                                        {index + 1}
                                      </h6>

                                      <div className="row">
                                        {/* ================= Pincode ================= */}
                                        <div className="col-md-4 pt-3">
                                          <FormControl
                                            variant="outlined"
                                            size="small"
                                            className="formControl col-md-12"
                                          >
                                            <label className="dropdown-label">
                                              <strong>MobileNo*</strong>
                                            </label>

                                            <TextField
                                              variant="outlined"
                                              size="small"
                                              value={
                                                this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.pincode || ""
                                              }
                                              onChange={(e) =>
                                                this.handleArchitectBlockPincodeChange(
                                                  e,
                                                  architectIndex,
                                                )
                                              }
                                              inputProps={{
                                                maxLength: 10,
                                              }}
                                              placeholder="Enter MobileNo."
                                              disabled={!this.state.isEditing}
                                              fullWidth
                                            />
                                          </FormControl>
                                        </div>

                                        {/* ================= Contractor ================= */}
                                        <div className="col-md-4 pt-3">
                                          <FormControl
                                            variant="outlined"
                                            size="small"
                                            className="formControl col-md-12"
                                          >
                                            <label className="dropdown-label">
                                              <strong>Contractor*</strong>
                                            </label>

                                            <Dropdown
                                              value={
                                                this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.selectedContractor?.value ||
                                                null
                                              }
                                              options={
                                                this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.contractors || []
                                              }
                                              optionLabel="label"
                                              optionValue="value"
                                              onChange={(e) =>
                                                this.handleArchitectBlockContractorChange(
                                                  e,
                                                  architectIndex,
                                                )
                                              }
                                              placeholder="Select Contractor"
                                              disabled={
                                                !this.state.isEditing ||
                                                this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.pincode?.length !== 10
                                              }
                                              filter
                                              showClear
                                              className="form-control custom-select"
                                              appendTo={document.getElementById(
                                                "root",
                                              )}
                                            />
                                          </FormControl>
                                        </div>

                                        {/* ================= Architect ================= */}
                                        <div className="col-md-4 pt-3">
                                          <FormControl
                                            variant="outlined"
                                            size="small"
                                            className="formControl col-md-12"
                                          >
                                            <label className="dropdown-label">
                                              {/* <strong>Architect*</strong> */}
                                              <strong>
                                                {this.state
                                                  .loyaltySelectedRoleName ||
                                                  "User"}{" "}
                                                *
                                              </strong>
                                            </label>

                                            {/* <Multiselect
                                              key={`architect-${architectIndex}-${
                                                this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.selectedArchitects?.length ||
                                                0
                                              }`}
                                              selectedValues={
                                                this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.selectedArchitects || []
                                              }
                                              options={
                                                this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.architects || []
                                              }
                                              displayValue="label"
                                              onSelect={(list) =>
                                                this.handleArchitectBlockSelection(
                                                  list,
                                                  architectIndex,
                                                )
                                              }
                                              onRemove={(list) =>
                                                this.handleArchitectBlockSelection(
                                                  list,
                                                  architectIndex,
                                                )
                                              }
                                              placeholder="Select Architect"
                                              disable={
                                                !this.state.isEditing ||
                                                !this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.selectedContractor
                                              }
                                              showCheckbox
                                              closeOnSelect={false}
                                            /> */}
                                            <Multiselect
                                              key={`architect-${architectIndex}-${
                                                this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.selectedArchitects?.length ||
                                                0
                                              }`}
                                              selectedValues={
                                                this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.selectedArchitects || []
                                              }
                                              options={
                                                this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.architects || []
                                              }
                                              displayValue="label"
                                              onSelect={(list) =>
                                                this.handleArchitectBlockSelection(
                                                  list,
                                                  architectIndex,
                                                )
                                              }
                                              onRemove={(list) =>
                                                this.handleArchitectBlockSelection(
                                                  list,
                                                  architectIndex,
                                                )
                                              }
                                              // placeholder="Select Architect"
                                              placeholder={`Select ${(
                                                this.state
                                                  .loyaltySelectedRoleName ||
                                                "users"
                                              ).toLowerCase()}s...`}
                                              disable={
                                                !this.state.isEditing ||
                                                !this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.selectedContractor
                                              }
                                              showCheckbox
                                              closeOnSelect={false}
                                            />
                                          </FormControl>
                                        </div>
                                      </div>

                                      {/* ================= Point Distribution ================= */}
                                      {this.state.architectBlocks?.[
                                        architectIndex
                                      ]?.selectedArchitects?.length > 0 && (
                                        <div className="col-md-12 pt-4">
                                          <div className="block-contractor-points-section">
                                            {/* <h6>
                                              Point Distribution for Architect -
                                              Block {index + 1}
                                            </h6> */}
                                            <h6>
                                              Point Distribution for{" "}
                                              {this.state
                                                .loyaltySelectedRoleName ||
                                                "User"}
                                              Block {index + 1}
                                            </h6>

                                            <DataTable
                                              value={
                                                this.state.architectBlocks?.[
                                                  architectIndex
                                                ]?.selectedArchitects || []
                                              }
                                              className="p-datatable-sm"
                                            >
                                              {/* {this.state.loyaltySelectedRoleName || "User"} Name */}
                                              <Column
                                                header={
                                                  this.state
                                                    .loyaltySelectedRoleName ||
                                                  "User"
                                                }
                                                Name
                                                body={(row) => row?.label || ""}
                                                style={{ width: "40%" }}
                                              />

                                              {/* Points */}
                                              <Column
                                                header="Points*"
                                                body={(row) => (
                                                  <input
                                                    type="number"
                                                    min="1"
                                                    step="0.01"
                                                    value={
                                                      this.state
                                                        .architectBlocks?.[
                                                        architectIndex
                                                      ]?.points?.[row.value] ??
                                                      ""
                                                    }
                                                    onChange={(e) =>
                                                      this.handleArchitectBlockPointsChange(
                                                        row.value,
                                                        e.target.value,
                                                        architectIndex,
                                                      )
                                                    }
                                                    className="form-control"
                                                    disabled={
                                                      !this.state.isEditing
                                                    }
                                                    style={{ width: "100px" }}
                                                  />
                                                )}
                                                style={{ width: "30%" }}
                                              />

                                              {/* Remove */}
                                              <Column
                                                header="Action"
                                                body={(row) => (
                                                  <Button
                                                    icon="pi pi-times"
                                                    className="p-button-danger p-button-sm"
                                                    onClick={() => {
                                                      const currentBlock =
                                                        this.state
                                                          .architectBlocks?.[
                                                          architectIndex
                                                        ];

                                                      const updatedArchitects =
                                                        (
                                                          currentBlock?.selectedArchitects ||
                                                          []
                                                        ).filter(
                                                          (architect) =>
                                                            String(
                                                              architect.value,
                                                            ) !==
                                                            String(row.value),
                                                        );

                                                      this.handleArchitectBlockSelection(
                                                        updatedArchitects,
                                                        architectIndex,
                                                      );
                                                    }}
                                                    disabled={
                                                      !this.state.isEditing
                                                    }
                                                  />
                                                )}
                                                style={{ width: "20%" }}
                                              />
                                            </DataTable>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </>
                              );
                            })()}
                          </>
                        ) : (
                          <>
                            <div className="col-md-12 pt-3">
                              <div className="block-contractor-selection-section">
                                {/* <h6>Contractor Selection for Block {index + 1}</h6> */}
                                <h6>
                                  {this.state.loyaltySelectedRoleName || "User"}{" "}
                                  Selection for Block {index + 1}
                                </h6>

                                <div className="row">
                                  <div className="col-md-12">
                                    <FormControl
                                      variant="outlined"
                                      size="small"
                                      className="formControl col-md-12"
                                    >
                                      <label className="dropdown-label">
                                        {/* <strong>Specific Contractors</strong> */}
                                        <strong>
                                          Specific{" "}
                                          {this.state.loyaltySelectedRoleName ||
                                            "User"}{" "}
                                        </strong>
                                      </label>

                                      <Multiselect
                                        key={`block-contractors-${index}-${(block.specificContractorIds || []).length}-${(block.SelectedDynamicId || []).length}`}
                                        displayValue="label"
                                        selectedValues={
                                          block.specificContractorIds || []
                                        }
                                        onSelect={(list) =>
                                          this.handleBlockSpecificContractorChange(
                                            list,
                                            index,
                                          )
                                        }
                                        onRemove={(list, item) =>
                                          this.handleBlockSpecificContractorRemove(
                                            list,
                                            item,
                                            index,
                                          )
                                        }
                                        // options={this.getFilteredContractors(
                                        //   block.SelectedDynamicId,
                                        // )}
                                        options={
                                          this.state.loyaltyRoleUsers || []
                                        }
                                        // placeholder="Select specific contractors..."
                                        placeholder={`Select specific ${(
                                          this.state.loyaltySelectedRoleName ||
                                          "users"
                                        ).toLowerCase()}s...`}
                                        disabled={
                                          !this.state.isEditing ||
                                          block.allContractorSelected
                                        }
                                        closeOnSelect={false}
                                      />
                                    </FormControl>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Block Contractor Points */}
                            {(block.specificContractorIds?.length > 0 ||
                              block.allContractorSelected) && (
                              <div className="col-md-12 pt-3">
                                <div className="block-contractor-points-section">
                                  {/* <h6>Contractor Points for Block {index + 1}</h6> */}
                                  <h6>
                                    {this.state.loyaltySelectedRoleName ||
                                      "User"}{" "}
                                    Selection for Block {index + 1}
                                  </h6>

                                  <div className="auto-fill-section mb-3">
                                    <div className="row">
                                      <div className="col-md-4">
                                        <TextField
                                          size="small"
                                          variant="outlined"
                                          placeholder="Enter points for all"
                                          inputRef={(el) => {
                                            this.blockContractorAutoFillInputs =
                                              this
                                                .blockContractorAutoFillInputs ||
                                              {};
                                            this.blockContractorAutoFillInputs[
                                              index
                                            ] = el;
                                          }}
                                          onKeyPress={(e) => {
                                            if (e.key === "Enter")
                                              this.handleBlockAutoFillContractorPoints(
                                                e.target.value,
                                                index,
                                              );
                                          }}
                                          disabled={!this.state.isEditing}
                                        />
                                      </div>

                                      <div className="col-md-4">
                                        <Button
                                          label="Auto Fill Points"
                                          className="p-button-success p-button-sm"
                                          onClick={() => {
                                            const input = (this
                                              .blockContractorAutoFillInputs ||
                                              {})[index];
                                            if (input)
                                              this.handleBlockAutoFillContractorPoints(
                                                input.value,
                                                index,
                                              );
                                          }}
                                          disabled={!this.state.isEditing}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <DataTable
                                    value={block.specificContractorIds}
                                    className="p-datatable-sm"
                                  >
                                    {/* <Column
                                  header="Contractor Name"
                                  body={(row) => row.label}
                                  style={{ width: "25%" }}
                                /> */}
                                    <Column
                                      header={`${this.state.loyaltySelectedRoleName || "User"} Name`}
                                      body={(row) =>
                                        row?.label || row?.contractorName
                                      }
                                      style={{ width: "30%" }}
                                    />

                                    <Column
                                      header="Points*"
                                      body={(row) => (
                                        <input
                                          type="number"
                                          min="1"
                                          step="0.00000000000001"
                                          value={
                                            block.specificContractorPoints?.[
                                              row.value
                                            ] || ""
                                          }
                                          onChange={(e) =>
                                            this.handleBlockContractorPointsChange(
                                              row.value,
                                              e.target.value,
                                              index,
                                            )
                                          }
                                          className="form-control"
                                          disabled={!this.state.isEditing}
                                          style={{ width: "100px" }}
                                        />
                                      )}
                                    />

                                    <Column
                                      header="Action"
                                      body={(row) => (
                                        <Button
                                          icon="pi pi-times"
                                          className="p-button-danger p-button-sm"
                                          onClick={() =>
                                            this.removeBlockContractor(
                                              row.value,
                                              index,
                                            )
                                          }
                                          disabled={!this.state.isEditing}
                                        />
                                      )}
                                    />
                                  </DataTable>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}

                    {/* ZONE-WISE POINTS TABLE (when AllContractor active for the block) */}
                    {((index === 0 && this.state.allContractorSelected) ||
                      (index > 0 && block.allContractorSelected)) && (
                      <div className="col-md-12 pt-3">
                        <div className="auto-fill-block-section mb-3">
                          <div className="row">
                            <div className="col-md-4">
                              <TextField
                                size="small"
                                variant="outlined"
                                placeholder="Enter points for all zones"
                                inputRef={(el) => {
                                  this.blockZoneAutoFillInputs =
                                    this.blockZoneAutoFillInputs || {};
                                  this.blockZoneAutoFillInputs[index] = el;
                                }}
                                onKeyPress={(e) => {
                                  if (e.key === "Enter")
                                    this.handleBlockAutoFillPoints(
                                      e.target.value,
                                      index,
                                    );
                                }}
                                disabled={!this.state.isEditing}
                              />
                            </div>

                            <div className="col-md-4">
                              <Button
                                label="Auto Fill All Points"
                                className="p-button-info p-button-sm"
                                onClick={() => {
                                  const input = (this.blockZoneAutoFillInputs ||
                                    {})[index];
                                  if (input)
                                    this.handleBlockAutoFillPoints(
                                      input.value,
                                      index,
                                    );
                                }}
                                disabled={!this.state.isEditing}
                              />
                            </div>
                          </div>
                        </div>

                        <DataTable
                          value={block.SelectedDynamicId}
                          className="p-datatable-sm"
                        >
                          <Column field="label" header="City Name" />

                          <Column
                            header="Points"
                            body={(row, { rowIndex }) => (
                              <input
                                type="number"
                                min="0"
                                step="any"
                                onChange={(e) =>
                                  this.handleBlockPointsChange(
                                    rowIndex,
                                    e.target.value,
                                    index,
                                  )
                                }
                                value={row.Points ?? ""}
                                disabled={!this.state.isEditing}
                                className="form-control"
                                style={{ width: "150px" }}
                              />
                            )}
                          />

                          <Column
                            header="Action"
                            body={(row, { rowIndex }) => (
                              <Button
                                icon="pi pi-times"
                                className="p-button-danger p-button-sm"
                                onClick={() =>
                                  this.confirmDeleteCityRow(
                                    index,
                                    rowIndex,
                                    row,
                                  )
                                }
                                disabled={!this.state.isEditing}
                              />
                            )}
                          />
                        </DataTable>
                      </div>
                    )}

                    {/* Delete block */}
                    {this.state.blocksSchemes.length > 1 && (
                      <div className="col-md-12 mt-2">
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => this.deleteBlock(index)}
                          disabled={!this.state.isEditing}
                        >
                          Delete Block
                        </button>
                      </div>
                    )}
                  </div>
                ) : null,
              )}

              {/* ADD BLOCK BUTTON */}
              <div className="col-md-12">
                <button
                  type="button"
                  className="btn btn-success mt-3"
                  onClick={this.addBlock}
                  disabled={
                    !this.state.isEditing ||
                    this.state.blocksSchemes.length >= 5
                  }
                >
                  + Add Block
                </button>
              </div>

              {/* SUBMIT BUTTON */}
              <div className="col-md-12 schememaster_submitbtncol mt-4 text-center">
                {/* <Button
                  label={this.state.buttonLabel}
                  onClick={this.submitForm}
                  icon="pi pi-check"
                  className="p-button-success"
                  disabled={!this.state.isEditing}
                /> */}
                <Button
                  label={this.state.buttonLabel}
                  onClick={this.submitForm}
                  icon="pi pi-check"
                  className="p-button-success"
                  disabled={!this.state.isEditing || isExpired}
                />
              </div>

              <div className="col-md-12">
                Note: Fields marked as (*) are required
              </div>
            </div>
          </div>

          {/* Optional Styles */}
          <style jsx>{`
            .contractor-selection-section {
              border: 1px solid #ddd;
              border-radius: 8px;
              padding: 15px;
              background: #f9f9f9;
            }
            .block-contractor-selection-section,
            .block-contractor-points-section {
              border: 1px solid #28a745;
              border-radius: 8px;
              padding: 15px;
              background: #f8fff8;
            }
            .auto-fill-section,
            .auto-fill-block-section {
              background: #e7f3ff;
              padding: 10px;
              border-radius: 5px;
            }
            .dropdown-label {
              font-weight: bold;
              margin-bottom: 5px;
              display: block;
            }
          `}</style>
        </Dialog>

        <Dialog
          header="Confirmation"
          visible={this.props.showIsActiveDialog}
          modal
          style={{ width: "350px" }}
          footer={renderFooter("displayConfirmation")}
          onHide={() => this.props.onHideShowIsActive(false)}
          onHide1={() => this.setState(false)}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle p-mr-3 confirm-icon"
              style={{ fontSize: "2rem" }}
            />
            <span>
              Are you sure you want to{" "}
              {this.state.switchAction == true ? "Active" : "InActive"}?
            </span>
          </div>
        </Dialog>
        <Dialog
          header={"Failed Mappings Data"}
          modal
          dismissableMask={false}
          visible={this.props.showErrorDialog}
          style={{ width: "50vw" }}
          onHide={this.onHideError}
        >
          <div className="datatable-selection-demo">
            <div className="card">
              <Toast ref={(el) => (this.toast = el)} />
              {this.props.ErrorData ? (
                <DataTable
                  value={this.props.ErrorData}
                  scrollable
                  responsive={true}
                  dataKey="id"
                  responsiveLayout="scroll"
                >
                  <Column
                    field="ProductCode"
                    header="Product Code"
                    sortable
                  ></Column>
                  <Column field="RoleName" header="Role Name" sortable></Column>
                  <Column
                    field="LoyaltyPoints"
                    header="Loyalty Points"
                    sortable
                  ></Column>
                  <Column field="Reason" header="Reason" sortable></Column>
                </DataTable>
              ) : (
                <h4 className="text-center"> No Data Available </h4>
              )}
            </div>
          </div>
        </Dialog>

        <Dialog
          header={
            <div style={{ paddingRight: "12px" }}>
              {this.state.selectedCity
                ? `${this.state.selectedCity} - Details`
                : "Details"}
            </div>
          }
          visible={this.state.showContractorPopup}
          onHide={() => this.setState({ showContractorPopup: false })}
        >
          {this.state.selectedCityContractors && (
            <div>
              {this.state.selectedCityContractors.map((c, i) => (
                <div key={i} style={{ marginBottom: "10px" }}>
                  {/* <p>
                    <strong>Contractor:</strong> {c.contractorName}
                  </p> */}
                  <p>
                    <strong>{this.state.selectedCityRoleName}:</strong>{" "}
                    {c.contractorName}
                  </p>

                  <p>
                    <strong>Points:</strong> {c.points}
                  </p>
                  <hr />
                </div>
              ))}
            </div>
          )}
        </Dialog>

        <Dialog
          header="City Details"
          visible={this.state.showZonePopup}
          style={{ width: "35vw" }}
          onHide={() => this.setState({ showZonePopup: false })}
        >
          {
            this.state.selectedZoneDetails
              ?.map((zone, index) => {
                const parsed = this.parseZone(zone);

                // ❌ SKIP if points = 0
                // if (Number(parsed.points) === 0) return null;
                const points = parseFloat(parsed.points);

                if (Number(points) === 0) return null;
                return (
                  <div key={index} style={{ marginBottom: "12px" }}>
                    <p>
                      <strong>City:</strong> {parsed.city}
                    </p>
                    <p>
                      <strong>Points:</strong> {parsed.points}
                    </p>
                    <hr />
                  </div>
                );
              })
              .filter(Boolean) /* removes nulls */
          }
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { archiCarpenterList } = state.loyalityscheme;
  return {
    StateData: state.dealer.stateddl,
    archiCarpenterList,
    SchememappingData: state.loyalityscheme.items,
    UserRoleData: state.role.rollddl,
    loyaltyRoleDropdownData: state.loyalityscheme.loyaltyRoleDropdownData || [],
    UserBCityData: state.dealer.bcityddl,
    DistrictData: state.dealer.Districtddl,
    FromNo: state.loyalityscheme.Mappseries?.[0]?.FromNo || "",
    Mappseries: state.loyalityscheme.Mappseries,
    showDialogue: state.loyalityscheme.showDialogue,
    CategoryDDL: state.product.prdctddl,
    showDialog: state.role.showDialog,
    loading: state.company.loding,
    showIsActiveDialog: state.loyalityscheme.showIsActiveDialog,
    showErrorDialog: state.loyalityscheme.showErrorDialog,
    ErrorData: state.loyalityscheme.ErrorData,
    loyaltypoints: state.loyalityscheme.loyaltypoints || [],
    loyalityschemeActions: state.loyalityscheme.data || [],
    contractDDL: state.loyalityscheme.contractDDL || [],
  };
};

const actionCreators = {
  getArchiCarpenterLoyaltyPoint:
    loyalityschemeActions.getArchiCarpenterLoyaltyPoint,
};
const mapDispatchToProps = (dispatch) => {
  return {
    getArchiCarpenterLoyaltyPoint: (data) => {
      return dispatch(
        loyalityschemeActions.getArchiCarpenterLoyaltyPoint(data),
      );
    },
    fetchApi: (obj) => {
      dispatch(loyalityschemeActions.getAll(obj));
    },
    getCategoryDDL: () => {
      dispatch(productMasterActions.getCategoryDDL());
    },
    getContractorDDL: () => {
      dispatch(loyalityschemeActions.getContractorDDL());
    },
    GetAvailableseries: (data) => {
      dispatch(loyalityschemeActions.GetAvailableseries(data));
    },
    createScheme: (user) => dispatch(loyalityschemeActions.createScheme(user)),
    updateScheme: (user) => dispatch(loyalityschemeActions.updateScheme(user)),
    inActiveRow: (SchemeId, isActive) =>
      dispatch(loyalityschemeActions.inActiveRow(SchemeId, isActive)),
    onHideShow: (isbool) => dispatch(loyalityschemeActions.onHideShow(isbool)),
    onHideShoww: (isbool) =>
      dispatch(loyalityschemeActions.onHideShoww(isbool)),
    onHideShowIsActive: (isbool) =>
      dispatch(loyalityschemeActions.onHideShowIsActive(isbool)),
    onHideShowError: (isbool) =>
      dispatch(loyalityschemeActions.onHideShowError(isbool)),
    getRoleDDL: (data) => dispatch(userMasterActions.getRoleDDL(data)),
    loadingData: (isLoding) =>
      dispatch(loyalityschemeActions.loadingData(isLoding)),
    getStateDDL: (data) => dispatch(dealerMasterActions.getStateDDL(data)),
    getBCityDDL: (data) => dispatch(dealerMasterActions.getBCityDDL(data)),
    showWarn: (message) => dispatch(alertActions.warning(message)),
    GetZoneWisePointList: (data) =>
      dispatch(loyalityschemeActions.GetZoneWisePointList(data)),
    getRoleDLLforPoint: (data) =>
      dispatch(loyalityschemeActions.getRoleDLLforPoint(data)),
    getDlrArctDistUsers: (roleId) => {
      return dispatch(loyalityschemeActions.getDlrArctDistUsers(roleId));
    },
    getArchitectsByContractor: (contractorId, roleId) => {
      return dispatch(
        loyalityschemeActions.getArchitectsByContractor(contractorId, roleId),
      );
    },

    getContractorsByPincode: (pincode) => {
      return dispatch(loyalityschemeActions.getContractorsByPincode(pincode));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(loyalityscheme);
